import { DatePipe, Location } from '@angular/common';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
declare var $: any;
import { FormBuilder, FormGroup, Validators, FormsModule, FormControl } from '@angular/forms';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { AnpiService } from '../../../_services/anpi-code.service';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '../../../_services/translate.service';
import { OwlDateTimeComponent } from 'ng-pick-datetime';
@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss'],

})
export class EmployeesComponent implements OnInit {
  selectedDate: Date = new Date();
  formattedDate: string;
  employeeWithCcps: any;
  employeeList = true;
  salaryRevise = false;
  public employeeWithCcpsForm1: FormGroup;
  isSubmitted = false;
  isSubmit = false;
  isSubmit2 = false;
  showFailedTitle = false;
  showSuccessTitle = false;
  currentLang: any;
  employeeDetails: any;
  bulkUploadDetails: any;
  response: any;
  imageUrl: any;
  allList: any;
  selectedValue = null;
  selectedNationalityValue = null;
  selectedEducationLevel = null;
  selectedBirthcountryValue = null;
  selectedregionValue = null;
  selectedCityValue = null;
  selectedDistrictValue = null;
  selectedNeighborhoodValue = null;
  selectedcontractValue = null;
  selectedmaritalValue = null;
  employee_gender = null;
  employeeGender = null;
  selectedEmployeeType: any = null;
  selectedProfessionalCategory: any = null;
  selectedMaritalStatus: any = null;
  resignReason = null;
  accountDetails: any;
  resubmit = false;
  title: any;
  id: any;
  regionList: any;
  educationLevelList: any;
  public withCcpsForm: FormGroup;
  public CcpsStage1Form: FormGroup;
  public resignationForm: FormGroup;
  public EmpolyeeBulkUploadForm: FormGroup;
  public contactForm: FormGroup;
  page: any;
  startat = new Date();
  todayDate: any = new Date();
  responseupload: any;
  id_Front_Photo: any;
  employee_Photo: any;
  civilStatusUrl: any;
  id_proof_url: any;
  birth_certificate_file_url: any;
  marriage_certificate_file_url: any;
  employee_birth_certificate_cnamgs_url: any;
  marriage_certificate_cnamgs_url: any;
  spouse_birth_certificate_cnamgs_url: any;
  payslips_url: any;
  employeeWithCcpsStage1 = false;
  showConfirmationQuestion = false;
  isRegisteredWithCNSS = 'yes'; // Default to 'yes'
  showCNAMGSQuestion = false; // Flag to show CNAMGS question after CNSS submission
  responseemployee: any;
  responselist: any;
  employeesallList: any;
  responsedetails: any;
  employeeData: any;
  idtype: any;
  idtypelist: any;
  educationList: any;
  countryList: any;
  employeespendingList: any;
  employeeTypeList: any[] = [];
  professionalRankList: any[] = [];
  maritalStatusList: any[] = [];
  professionalCategoryList: any[] = [];
  administrativeStatusList: any[] = [];
  affiliationTypeList: any[] = [];
  categoryList: any[] = [];
  categoryListPublic: any[] = [];
  categoryListPrivate: any[] = [];
  employeeDataList: any;
  idArray: any;
  pendingEmployeeCount: string;
  employeeDetail: any;
  rsubmitted = false;
  responseresign: any;
  searchList: any;
  bulkUploadSuccess: any;
  bulkUploadFailed: any;
  selectedBulkUploadYear: any;
  selectedBulkUploadQuarter: any;
  minReportDate: Date;
  ccpsId: any;
  cityList: any;
  minJoinDate: Date = new Date();
  minDobDate: Date = new Date();
  districtList: null;
  neighborhoodList: null;
  contract: any;
  rejectReason: any;
  employee_birth_Certificate = false;
  employeeCIvilstatus = false;
  employeeCNationality = false;
  employeeBeforeSubmit: boolean = false;
  isFromNoCnssRegistration: boolean = false;
  isFromNoCnamgsRegistration: boolean = false;
  isFromCnamgsYesRegistration: boolean = false;
  showCnamgsYesForm: boolean = false; // Flag to show additional form after CNAMGS "Yes" submission
  resign_reason_document: any
  resign_reason: any;
  resultList: any;
  currentPage = 0;
  itemsPerPage = 20;
  totalItems = 0;
  pageSizeOptions: number[] = [this.itemsPerPage];
  pageSize: number[] = [10];
  spouse_birthCertificate_url: any;
  spouseCertificate_url: any;
  showAll: boolean = false;
  maxDateOfBirth: Date = new Date();
  employeeNifNumber: any;
  months = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' }
  ];
  availableMonths: { value: number; label: string }[] = [];
  salaryList: { month: number; amount: number; salary_id?: number }[] = [];
  // New structure for year-wise salary management
  salaryListByYear: { [year: string]: { month: string; value: number; salary_id?: number }[] } = {};
  expandedYears: { [year: string]: boolean } = {};
  currentYear: number = new Date().getFullYear();
  availableYears: number[] = [];
  isEditing = false;
  editingIndex: number | null = null;
  editingYear: string | null = null;
  isCNSSSectionValue: boolean = false;
  isCnamgsSectionValue: boolean = false;
  isCnssEmployeeRegistrationFlow: boolean = false;
  isCnamgsEmployeeRegistrationFlow: boolean = false;
  hideCnamgsSection: boolean = false;
  hideCnssSection: boolean = false;
  nifNumberEmployeeName: any;
  fingerprintsData: any;
  facialBiometricsData: any;
  showCnssSection = false;
  @ViewChild('dt460', { static: false }) dateTimePicker: OwlDateTimeComponent<Date>;
  employeeNipNumber: any;
  formInitialized: boolean = false; // Flag to track if form has been initialized with API data
  isSuccessModal: any;
  modalHeading: any;
  modalDescription: any;
  hideFormSectionsOnNo: boolean = false; // Flag to hide form sections when "No" is selected in hiring flow
  employeeHasNoId: boolean = false; // Flag for "Don't have ID" flow - skip API, show form with first/last name

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private api: ApiService,
    private router: Router,
    private paginatorIntl: MatPaginatorIntl,
    private anpiService: AnpiService,
    private datePipe: DatePipe,
    private ngxUiLoaderService: NgxUiLoaderService,
    private location: Location,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private elementRef: ElementRef,
    private http: HttpClient) {
    // this.minJoinDate.setFullYear(this.minJoinDate.getFullYear() - 70);
    this.minDobDate.setFullYear(this.minDobDate.getFullYear() - 86);
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      console.log(this.accountDetails)
      this.minJoinDate = new Date(this.accountDetails.company_creation_date)
      this.minJoinDate.setHours(0, 0, 0, 0);
      this.minReportDate = new Date(this.accountDetails.company_creation_date);
    } else {
      this.minReportDate = new Date();
    }
    this.maxDateOfBirth.setFullYear(this.maxDateOfBirth.getFullYear() - 16);
    console.log("133", this.maxDateOfBirth)
    this.checkLocalStorage();
    // const data = localStorage.getItem('employees');
    // if (data == '1') {
    //   this.employeeList = false;
    // }
    if (this.router.getCurrentNavigation().extras.state) {
      const data = this.router.getCurrentNavigation().extras.state.show_add_Employee
      if (data == 1) {
        setTimeout(() => {
          $('#addEmployeeModal').modal('show');
        }, 500);
      }
    }

  }

  // Map numeric month id to month label for display
  monthName(monthId: number): string {
    const found = this.months.find(m => m.value === Number(monthId));
    return found ? found.label : String(monthId);
  }

  // Get month name from string month (e.g., "01" -> "January")
  getMonthName(monthStr: string): string {
    const monthNum = parseInt(monthStr, 10);
    const found = this.months.find(m => m.value === monthNum);
    return found ? found.label : monthStr;
  }

  ngOnInit() {
    // Load employee dropdown options from JSON file
    // this.loadEmployeeData();
    // Check for openModal query parameter to open add employee modal
    const openModal = this.route.snapshot.queryParams['openModal'];
    if (openModal === 'addEmployee') {
      // Clear the query parameter from URL
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {},
        replaceUrl: true
      });
      // Open the modal after a short delay to ensure component is fully initialized
      setTimeout(() => {
        this.withCcpsIdFormCall();
      }, 500);
    }



    // Subscribe to route query params changes to handle navigation
    this.route.queryParams.subscribe(params => {
      // Check for openModal query parameter to open add employee modal
      if (params['openModal'] === 'addEmployee') {
        // Clear the query parameter from URL
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {},
          replaceUrl: true
        });
        // Reset all flow flags to ensure clean state for Hiring flow
        this.isCnssEmployeeRegistrationFlow = false;
        this.isCnamgsEmployeeRegistrationFlow = false;
        this.hideCnssSection = false;
        this.hideCnamgsSection = false;
        this.isCNSSSectionValue = false;
        this.isCnamgsSectionValue = false;
        this.employeeHasNoId = false;
        this.isSubmit = false; // Reset submit flag to hide validation messages
        this.isSubmitted = false; // Reset submitted flag
        // Open the modal after a short delay to ensure component is fully initialized
        setTimeout(() => {
          this.withCcpsIdFormCall();
        }, 500);
        return; // Exit early to avoid processing other params
      }

      // Check for CNSS employee registration flow
      if (params['openModal'] === 'cnssEmployeeRegistration') {
        // Clear the query parameter from URL
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {},
          replaceUrl: true
        });
        // Reset ALL flow flags to ensure clean state
        this.isCnamgsEmployeeRegistrationFlow = false;
        this.isCnssEmployeeRegistrationFlow = true;
        this.hideCnssSection = false;
        this.hideCnamgsSection = true; // Hide CNAMGS section in CNSS flow
        this.isCNSSSectionValue = false;
        this.isCnamgsSectionValue = true; // Hide CNAMGS display section
        this.showCnssSection = false; // Will be set after API call
        this.hideFormSectionsOnNo = false; // Reset hiring flow flag
        this.employeeWithCcpsStage1 = false; // Reset hiring flow flag
        this.employeeHasNoId = false;
        this.isSubmit = false; // Reset submit flag to hide validation messages
        this.isSubmitted = false; // Reset submitted flag
        // Open the modal after a short delay to ensure component is fully initialized
        setTimeout(() => {
          this.withCcpsIdFormCall();
        }, 500);
        return; // Exit early to avoid processing other params
      }

      // Check for CNAMGS employee registration flow
      if (params['openModal'] === 'cnamgsEmployeeRegistration') {
        // Clear the query parameter from URL
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {},
          replaceUrl: true
        });
        // Reset ALL flow flags to ensure clean state
        this.isCnssEmployeeRegistrationFlow = false;
        this.isCnamgsEmployeeRegistrationFlow = true;
        this.hideCnssSection = true; // Hide CNSS section in CNAMGS flow
        this.hideCnamgsSection = false;
        this.isCNSSSectionValue = true; // Hide CNSS display section
        this.isCnamgsSectionValue = false;
        this.showCnssSection = false; // Reset CNSS section flag
        this.hideFormSectionsOnNo = false; // Reset hiring flow flag
        this.employeeWithCcpsStage1 = false; // Reset hiring flow flag
        this.employeeHasNoId = false;
        this.isSubmit = false; // Reset submit flag to hide validation messages
        this.isSubmitted = false; // Reset submitted flag
        // Open the modal after a short delay to ensure component is fully initialized
        setTimeout(() => {
          this.withCcpsIdFormCall();
        }, 500);
        return; // Exit early to avoid processing other params
      }

      if (params['cns'] === 'yes') {
        this.employeeWithCcpsStage1 = true;
        this.employeeList = false;
        // If cnamgs=yes is in route, show CNAMGS question and set CNAMGS registration to 'yes'
        if (params['cnamgs'] === 'yes') {
          setTimeout(() => {
            this.showCNAMGSQuestion = true;
            const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
            if (isRegisteredCnamgsControl) {
              isRegisteredCnamgsControl.setValue('yes');
            }
          }, 100);
        }
      } else if (params['cnamgs'] === 'yes') {
        // If only cnamgs=yes is in route (without cns), still show the form and CNAMGS question
        this.employeeWithCcpsStage1 = true;
        this.employeeList = false;
        setTimeout(() => {
          // Set CNSS registration to 'yes' if not already set
          const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
          if (isRegisteredCnssControl && (!isRegisteredCnssControl.value || isRegisteredCnssControl.value === '')) {
            isRegisteredCnssControl.setValue('yes');
          }
          // Show CNAMGS question
          this.showCNAMGSQuestion = true;
          const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
          if (isRegisteredCnamgsControl) {
            isRegisteredCnamgsControl.setValue('yes');
          }
        }, 100);
      }
    });

    this.todayDate.setHours(23, 59, 59, 999);
    this.startat.setHours(0, 0, 0, 0);
    this.minDobDate.setHours(0, 0, 0, 0);
    this.maxDateOfBirth.setHours(0, 0, 0, 0);
    console.log("155", this.maxDateOfBirth)
    console.log("153startat", this.startat)
    console.log("58", this.selectedDate)
    this.anpiService.changeEvent.subscribe(() => {
      console.log('inside employees emit event')
      this.checkLocalStorage();
      // Re-check query params after checkLocalStorage in case it was reset
      const cnsAfterCheck = this.route.snapshot.queryParams['cns'];
      if (cnsAfterCheck === 'yes') {
        this.employeeWithCcpsStage1 = true;
        this.employeeList = false;
      }
    });
    this.getResignReasonList()

    this.currentLang = localStorage.getItem('language') || "fr";
    console.log("this.currentLang", this.currentLang);

    this.translate.use(this.currentLang).then((translations: any) => {
      this.translateLabels(translations);
    });

    this.withCcpsForm = this.formBuilder.group({
      ccpsid: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9]+$")]],
    });
    this.CcpsStage1Form = this.formBuilder.group({

      first_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$")]],
      last_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$")]],
      maiden_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$")]],
      first_father_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$")]],
      last_father_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$")]],
      first_mother_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$")]],
      last_mother_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$")]],
      // first_and_lastname_ofmother: [''],
      dob: ['', [Validators.required]],
      birthplace: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      // number_of_civil_status_document: [''],
      birthcountry: [''],
      gender: ['', [Validators.required]],
      mobile: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(8), Validators.maxLength(8)]],
      address: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      post_box: ['', [Validators.pattern("^(?! *$)[a-zA-Z0-9 -]+$")]],
      details_of_location: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      employee_education_level: [''],
      other_qualification: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      //employee_education_level: [''],
      // company_id: [''],
      email: ['', [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      is_registered_cnss: ['yes'],
      cnss: [''],
      is_registered_cnamgs: ['yes'],
      cnamgs: [''],

      id_type: ['', [Validators.required]],
      nationality: ['', [Validators.required]],
      region: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      city: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      specialty: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      district: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      neighborhood: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      // Birth location fields
      birth_region: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      birth_city: ['', [ Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      birth_district: ['', [ Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      birth_neighborhood: ['', [ Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      type_of_contract: ['', [Validators.required]],
      marital_status: ['', [Validators.required]],
      marital_status_other: ['', [Validators.required]],
      id_number: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      imageFile: ['', []],
      employee_Photo: ['', [Validators.required]],
      spouse_birth_certificate: [''],
      spouse_certificate: [''],
      id_Front_Photo: ['', [Validators.required]],
      // civil_status_document: [''],
      joindate: ['', [Validators.required]],
      position: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      base_salary: ['', [Validators.pattern("^[0-9]*$")]],
      salary_slip_no: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      // select_period: [this.getPreviousMonth()], // Year and Month picker field - defaults to previous month,
      nip_number: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      year: [this.currentYear], // Default to current year
      month: [''],
      amount: [null, [Validators.pattern("^[0-9]*$")]],
      // Fields for non-CNSS registration (when is_registered_cnss === 'no')
      birth_certificate_number: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      birth_certificate_issue_date: [''],
      id_proof_expiry_date: [''],
      professional_category: ['', [Validators.required]],
      professional_category_other: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      employee_type: ['', [Validators.required]],
      employee_type_other: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      hiring_certificate_date: [''],
      professional_rank: [null, [Validators.required]],
      contract_end_date: [''],
      birth_certificate_file: [''],
      marriage_certificate_file: [''],
      // Fields for CNAMGS 'No' registration
      marriage_date: [''],
      // administrative_status_public: ['', [Validators.required]],
      administrative_status_private: ['', [Validators.required]],
      fingerprint: [''],
      facial_biometrics: [''],
      // administration_code: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      // affiliation_type: ['', [Validators.required]],
      // employee_id: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      // index: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      // grade: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      category: [''],
      // category_public: [''],
      category_private: [''],
      employment_start_date: [''],
      nature_of_activity: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      employer_organization_id: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      employee_id_employer: ['', [Validators.pattern("^[a-zA-Z0-9 -]+$")]],
      id_proof: [''],
      employee_birth_certificate_cnamgs: [''],
      marriage_certificate_cnamgs: [''],
      spouse_birth_certificate_cnamgs: [''],
      payslips: [''],
      // salary: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
    });
    // this.employeeWithCcpsForm1 = this.formBuilder.group({
    //   first_name: ['', []],  
    //   last_name: ['', []],
    // });
    this.resignationForm = this.formBuilder.group({
      date_of_resignation: ['', [Validators.required]],
      reason: ['', [Validators.required]],
      reason_type: ['', []],
      resign_reason_document: [''],
    });
    this.EmpolyeeBulkUploadForm = this.formBuilder.group({
      bulkUpload: ['', [Validators.required]]
    })
    this.contactForm = this.formBuilder.group({
      year: ['', [Validators.required]],
      quarter: ['', [Validators.required]]
    });
    if (!this.api.getValidationStatus()) {
      // this.api.getFormValidation(this.withCcpsForm);
      this.api.getFormValidation(this.CcpsStage1Form);
      this.api.getFormValidation(this.employeeWithCcpsForm1);
    }

    // Initialize salary-related arrays after form is created
    this.initMonthsUpToPrevious();
    this.initAvailableYears();
    // Subscribe to CNSS registration changes
    this.subscribeToCNSSRegistrationChanges();
    this.subscribeToCNAMGSRegistrationChanges();
    this.initializeYearExpansion();
    this.subscribeToJoinDateChanges();
    this.subscribeToIdTypeChanges();

    this.getEmployeeList(1);
    $(document).ready(() => {
      $("#WithCcpsForm1").click(() => {
        //this.idTypeList();
        this.resetFields();
        this.getCountryData();
        this.getRegionData();
        this.contractTypeList();
        this.getEducationList()
        this.clearJoinDate();
        $('#addEmployeeModal').modal('hide');
        setTimeout(function () {
          $('#employeeWithCcpsModal').modal('show');
        }, 500);

        this.employeeWithCcps = true;
        console.log("employeeWithCcps", this.employeeWithCcps)
      });
      $("#WithoutCcpsForm1").click(() => {
        this.rejectReason = null;
        //this.idTypeList();
        this.resetFields();
        this.getCountryData();
        this.getRegionData();
        this.contractTypeList();
        this.getEducationList();
        this.clearJoinDate();
        this.updateDobDate();

        this.employeeData = null;
        this.makeInputEditable();
        console.log("267minJoinDate", this.minJoinDate)
        $('#addEmployeeModal').modal('hide');
        setTimeout(() => {
          this.employeeWithCcpsStage1 = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 500);
        console.log("700")
        this.employeeWithCcps = false;
        console.log(this.employeeWithCcps)
      });
    });

    this.currentLang = localStorage.getItem('language') || "fr";
    console.log("104", this.currentLang)
    this.translate.use(this.currentLang).then((translations: any) => {
      this.translateLabels(translations);
    });
  }

  registerNewEmployee() {
    if ($('#allEmployeeModal').hasClass('show')) {
      $('#allEmployeeModal').modal('hide');
    }
    this.rejectReason = null;

    // Reset all flow flags to ensure clean state
    this.isCnssEmployeeRegistrationFlow = false;
    this.isCnamgsEmployeeRegistrationFlow = false;
    this.hideCnssSection = false;
    this.hideCnamgsSection = false;
    this.isCNSSSectionValue = false;
    this.isCnamgsSectionValue = false;
    this.showCNAMGSQuestion = false;
    this.showCnamgsYesForm = false;
    this.employeeHasNoId = false;
    this.clearNoIdValidators();

    // Reset fields and prepare for new employee entry
    this.resetFields();

    // Clear routing parameters
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {}
    });

    // Reset employee data
    this.employeeData = null;
    this.ccpsId = null;
    this.employeeWithCcpsStage1 = false;
    this.employeeList = false;
    this.salaryList = [];

    // Show the CCPS ID modal (same as when coming from hiring header)
    this.withCcpsIdFormCall();
  }

  updateDobDate() {
    this.maxDateOfBirth = new Date();
    this.maxDateOfBirth.setFullYear(this.maxDateOfBirth.getFullYear() - 16);
    this.maxDateOfBirth.setHours(0, 0, 0, 0);
    console.log("292", this.maxDateOfBirth)
  }

  getEducationList() {
    this.api.getEducationLists().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        if (data.status == 200) {
          this.educationList = data.results;
          console.log(this.educationList, "265")
        } else {
          this.snackBar.open(data.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }
  getResignReasonList() {
    this.api.getResignReasonLists().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        if (data.status == 200) {
          this.resign_reason = data.results;
          console.log(this.educationList, "265")
        } else {
          this.snackBar.open(data.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }
  customCnamgsFormatValidator() {
    return (control) => {
      const cnamgsValue = control.value;
      const cnamgsRegex = /^\d{3}-\d{3}-\d{3}-\d{3}$/; // Regular expression for the specified format

      if (!cnamgsRegex.test(cnamgsValue)) {
        return { invalidCnamgsFormat: true };
      } else {
        return null;
      }
    };
  }

  checkLocalStorage() {
    if (this.accountDetails && this.accountDetails.GNI == 0) {
      this.title = 'business';
      this.employeeList = true;
      console.log("138", this.title)
      setTimeout(function () {
        $('#addEmployeeContainer').css('display', 'none');
      }, 100);
    } else if (this.accountDetails.GNI && this.accountDetails.BankDetails == 0) {
      this.title = 'bank';
      this.employeeList = true;
      console.log("143", this.title)
      setTimeout(function () {
        $('#addEmployeeContainer').css('display', 'none');
      }, 100);
    } else if (this.accountDetails.GNI && this.accountDetails.BankDetails && this.accountDetails.EmployeeDetails == 0) {
      this.employeeList = true;
      this.title = 'employees';
      console.log("148", this.title)
      setTimeout(function () {
        $('#addEmployeeContainer').css('display', 'flex');
      }, 100);
    }
  }
  closeSuccessModal() {
    this.getEmployeeList(3); // Use 3 to prevent auto-opening the "List of Employees to Add" modal
    $('#addEmployeeSuccessModal').modal('hide');
  }
  closeModal(val = null) {

    this.showFailedTitle = false;
    this.showSuccessTitle = false
    console.log("215")
    this.withCcpsForm.reset();
    this.CcpsStage1Form.reset();
    // Set yearMonth back to previous month after reset
    // this.CcpsStage1Form.get('select_period').setValue(this.getPreviousMonth());
    // Set nationality back to default
    this.CcpsStage1Form.get('nationality').setValue('77');
    // Set year back to current year
    this.CcpsStage1Form.get('year').setValue(this.currentYear);
    // Set CNSS registration back to default 'yes'
    this.CcpsStage1Form.get('is_registered_cnss').setValue('yes');
    // Set CNAMGS registration back to default 'yes'
    this.CcpsStage1Form.get('is_registered_cnamgs').setValue('yes');
    // Reset CNAMGS question flag
    this.showCNAMGSQuestion = false;
    // Reset flags
    this.isFromNoCnssRegistration = false;
    this.isFromNoCnamgsRegistration = false;
    this.isFromCnamgsYesRegistration = false;
    // Reset ccpsId when closing modal
    this.ccpsId = null;
    this.resignationForm.reset();
    this.isSubmitted = false;
    this.isSubmit = false;
    this.isSubmit2 = false;
    this.rsubmitted = false;
    this.showConfirmationQuestion = false;
    // Reset CNAMGS question flag
    this.showCNAMGSQuestion = false;
    
    // Reset registration flow flags when modal is closed
    this.isCnssEmployeeRegistrationFlow = false;
    this.isCnamgsEmployeeRegistrationFlow = false;
    this.showCnssSection = false;
    this.employeeHasNoId = false;
    this.clearNoIdValidators();

    if (val) {
      this.getEmployeeList(3);
    }
    console.log("38")
    $('#addEmployeeModal').modal('hide');
    $('#employeeWithCcpsModal').modal('hide');
    $('#employeeWithCcpsStage1').modal('hide');
    $('#employeeResignModal').modal('hide');
    $('#bulkUpload').modal('hide');
    $('#allEmployeeModal').modal('hide');
    $('#bulkUploadSuccesssModal').modal('hide');

    this.makeInputEditable();
    document.addEventListener('DOMContentLoaded', (event) => { });

    // Only reset employeeWithCcpsStage1 if cns query param is not present
    const cns = this.route.snapshot.queryParams['cns'];
    if (this.employeesallList && this.employeesallList.length) {
      this.employeeList = false;
      if (cns !== 'yes') {
        this.employeeWithCcpsStage1 = false;
      }
    } else {
      if (cns !== 'yes') {
        this.employeeWithCcpsStage1 = false;
      }
    }
  }

  reuploadPayrollFile() {
    // Close the current failed modal
    $('#bulkUploadSuccesssModal').modal('hide');
    // Reset the bulk upload form
    this.EmpolyeeBulkUploadForm.reset();
    // Open the bulk upload modal
    setTimeout(() => {
      $('#reportModal').modal('show');
    }, 300);
  }

  onSubmitEmployeeStage1() {
    console.log(this.withCcpsForm.value)
    this.isSubmitted = true;
    if (this.withCcpsForm.invalid) {
      return;
    }

    let entityType = '1';
    if (this.isCnssEmployeeRegistrationFlow) {
      entityType = '2';
    } else if (this.isCnamgsEmployeeRegistrationFlow) {
      entityType = '3';
    }


    const data = {
      nip_number: this.withCcpsForm.value.ccpsid,
      entity_type: entityType
    }
    this.ngxUiLoaderService.start();
    this.api.employeeHiring(data).pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();
        this.response = data;
        console.log(this.response, "response")
        if (this.response.status == 200) {
          this.employeeNifNumber = this.response.results.nif;
          this.employeeNipNumber = this.response.results.nip_number;
          this.nifNumberEmployeeName = this.response.results.full_name;
          this.isSubmitted = false;
          this.showConfirmationQuestion = true;
          this.snackBar.open(this.response.message, "ok", {
            duration: 2000,
          });
        } else {
          this.snackBar.open(this.response.message, "ok", {
            duration: 2000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }

  onConfirmationYes() {
    // Determine entity_type based on the flow:
    // 1 = Hiring, 2 = CNSS employee registration, 3 = CNAMGS employee registration
    let entityType = '1';
    if (this.isCnssEmployeeRegistrationFlow) {
      entityType = '2';
    } else if (this.isCnamgsEmployeeRegistrationFlow) {
      entityType = '3';
    }

    const data = {
      nip_number: this.employeeNipNumber,
      entity_type: entityType
    }
    this.ccpsId = data;
    this.ngxUiLoaderService.start();
    this.api.employeeHiringDetails(data).pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();
        this.responsedetails = data;
        if (this.responsedetails.status == 200) {
          this.snackBar.open(this.responsedetails.message, "ok", {
            duration: 2000,
          });
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.employeeData = this.responsedetails.results;
          this.nifNumberEmployeeName = this.employeeData.full_name;
          this.employeeNifNumber = this.employeeData.nif;
          this.employeeNipNumber = this.employeeData.nip_number;
          this.fingerprintsData = this.employeeData.fingerprint;
          this.facialBiometricsData = this.employeeData.facial_biometrics;
          $('#employeeWithCcpsModal').modal('hide');
          this.withCcpsForm.reset();
          this.showConfirmationQuestion = false;
          this.employeeWithCcpsStage1 = true;
          
          // Reset submit flags to hide validation messages when form is initialized
          this.isSubmit = false;
          this.isSubmitted = false;
          
          // Clear touched state of all form controls to hide validation messages
          this.CcpsStage1Form.markAsUntouched();
          this.CcpsStage1Form.markAsPristine();

          // Populate form fields from employeeData
          // Use setTimeout to ensure form controls are ready before populating
          setTimeout(() => {
            if (this.employeeData) {
              this.setEmployeeDetailsValues();
              this.formInitialized = true; // Mark form as initialized
            }
          }, 200);

          // Check if this is CNSS employee registration flow
          if (this.isCnssEmployeeRegistrationFlow) {
            // CNSS Employee Registration Flow: Show only CNSS registration form
            this.hideCnamgsSection = true; // Hide CNAMGS section completely
            this.hideCnssSection = false; // Ensure CNSS section is visible
            this.isCNSSSectionValue = false;
            this.isCnamgsSectionValue = true; // Hide CNAMGS display section
            this.showCnssSection = true; // Show CNSS registration form
            this.hideFormSectionsOnNo = false; // Reset hiring flow flag


            setTimeout(() => {
              const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
              if (isRegisteredCnssControl) {
                isRegisteredCnssControl.setValue('no'); // Set to "no"
              }

              // Clear CNSS value
              const cnssControl = this.CcpsStage1Form.get('cnss');
              if (cnssControl) {
                cnssControl.setValue('');
              }

              // Reset CNAMGS to default
              const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
              if (isRegisteredCnamgsControl) {
                isRegisteredCnamgsControl.setValue('yes');
              }

              // Populate common fields for CNSS Registration form
              if (this.employeeData && !this.formInitialized) {
                this.setCommonFormFields();
              }
            }, 100);
          } else if (this.isCnamgsEmployeeRegistrationFlow) {
            // CNAMGS Employee Registration Flow: Show only CNAMGS registration form
            this.hideCnssSection = true; // Hide CNSS section completely
            this.hideCnamgsSection = false; // Ensure CNAMGS section is visible
            this.isCNSSSectionValue = true; // Hide CNSS display section
            this.isCnamgsSectionValue = false;
            this.showCnssSection = false; // Reset CNSS section flag
            this.hideFormSectionsOnNo = false; // Reset hiring flow flag


            setTimeout(() => {
              const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
              if (isRegisteredCnamgsControl) {
                isRegisteredCnamgsControl.setValue('no'); // Set to "no"
              }

              // Clear CNAMGS value
              const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
              if (cnamgsControl) {
                cnamgsControl.setValue('');
              }

              // Set CNSS to 'yes' so CNAMGS registration form condition is satisfied
              const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
              if (isRegisteredCnssControl) {
                isRegisteredCnssControl.setValue('yes');
              }

              // Populate common fields for CNAMGS Registration form
              if (this.employeeData && !this.formInitialized) {
                this.setCommonFormFields();
              }
            }, 100);
          } else {
            // Normal Hiring Flow: Conditionally show display or form sections based on is_cnss and is_cnamgs flags
            // Ensure both sections are visible (reset hide flags)
            this.hideCnssSection = false;
            this.hideCnamgsSection = false;
            // Reset submit flags for hiring flow
            this.isSubmit = false;
            this.isSubmitted = false;

            // CNSS Section Logic: Check is_cnss flag to determine display vs form section
            this.isCNSSSectionValue = (this.employeeData && this.employeeData.is_cnss === true);

            // CNAMGS Section Logic: Check is_cnamgs flag to determine display vs form section
            this.isCnamgsSectionValue = (this.employeeData && this.employeeData.is_cnamgs === true);

            // Populate form controls based on section type
            setTimeout(() => {
              // CNSS Form Controls
              const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
              const cnssControl = this.CcpsStage1Form.get('cnss');
              
              if (isRegisteredCnssControl) {
                // Always set to 'yes' (default for both display and form sections)
                isRegisteredCnssControl.setValue('yes');
              }

              if (cnssControl) {
                if (this.isCNSSSectionValue) {
                  // Display section: Populate value from employeeData
                  const cnssValue = (this.employeeData && this.employeeData.cnss) ? this.employeeData.cnss : '';
                  cnssControl.setValue(cnssValue);
                } else {
                  // Form section: Leave empty for user entry
                  cnssControl.setValue('');
                }
              }

              // CNAMGS Form Controls
              const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
              const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
              
              if (isRegisteredCnamgsControl) {
                // Always set to 'yes' (default for both display and form sections)
                isRegisteredCnamgsControl.setValue('yes');
              }

              if (cnamgsControl) {
                if (this.isCnamgsSectionValue) {
                  // Display section: Populate value from employeeData
                  const cnamgsValue = (this.employeeData && this.employeeData.cnamgs) ? this.employeeData.cnamgs : '';
                  cnamgsControl.setValue(cnamgsValue);
                } else {
                  // Form section: Leave empty for user entry
                  cnamgsControl.setValue('');
                }
              }
            }, 100);
          }

          // Query parameters removed - no longer needed

        } else {
          this.snackBar.open(this.responsedetails.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
          this.isSubmitted = false;
        });
  }

  onConfirmationNo() {
    $('#employeeWithCcpsModal').modal('hide');
    this.withCcpsForm.reset();
    this.showConfirmationQuestion = false;
    this.isSubmitted = false;
  }

  /**
   * Apply required validators to first_name and last_name for no-ID flow.
   */
  applyNoIdValidators() {
    const firstNameControl = this.CcpsStage1Form.get('first_name');
    const lastNameControl = this.CcpsStage1Form.get('last_name');
    if (firstNameControl) {
      firstNameControl.setValidators([Validators.required, Validators.pattern('^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$')]);
      firstNameControl.updateValueAndValidity();
    }
    if (lastNameControl) {
      lastNameControl.setValidators([Validators.required, Validators.pattern('^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$')]);
      lastNameControl.updateValueAndValidity();
    }
  }

  /**
   * Clear required validators from first_name and last_name (used when exiting no-ID flow).
   */
  clearNoIdValidators() {
    const firstNameControl = this.CcpsStage1Form.get('first_name');
    const lastNameControl = this.CcpsStage1Form.get('last_name');
    if (firstNameControl) {
      firstNameControl.clearValidators();
      firstNameControl.setValidators([Validators.pattern('^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$')]);
      firstNameControl.updateValueAndValidity();
    }
    if (lastNameControl) {
      lastNameControl.clearValidators();
      lastNameControl.setValidators([Validators.pattern('^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$')]);
      lastNameControl.updateValueAndValidity();
    }
  }

  onNoIdClick() {
    this.employeeHasNoId = true;
    this.employeeData = null;
    this.employeeNifNumber = null;
    this.employeeNipNumber = null;
    this.nifNumberEmployeeName = '';
    $('#employeeWithCcpsModal').modal('hide');
    this.withCcpsForm.reset();
    this.showConfirmationQuestion = false;
    this.isSubmitted = false;

    if (!this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow) {
      // Hiring flow: show CNSS and CNAMGS entry sections
      this.isCNSSSectionValue = false;
      this.isCnamgsSectionValue = false;
      this.hideCnssSection = false;
      this.hideCnamgsSection = false;
    } else if (this.isCnssEmployeeRegistrationFlow) {
      this.showCnssSection = true;
      this.hideCnamgsSection = true;
      this.hideCnssSection = false;
    }
    // CNAMGS flow: form already shown via isCnamgsEmployeeRegistrationFlow

    this.employeeWithCcpsStage1 = true;
    this.applyNoIdValidators();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  showcnamgs() {
    // Check if CNSS "Yes" is selected
    const isRegisteredCnssValue = this.g.is_registered_cnss.value;
    if (isRegisteredCnssValue === 'yes') {
      // Show loading
      this.ngxUiLoaderService.start();

      // Query parameters removed - no longer needed

      // Show CNAMGS question section
      this.showCNAMGSQuestion = true;

      // Wait for DOM update, then scroll to CNAMGS section and stop loading
      setTimeout(() => {
        const cnamgsSection = document.getElementById('cnamgs-registration-section');
        if (cnamgsSection) {
          cnamgsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.ngxUiLoaderService.stop();
      }, 500);
    }
  }
  onSubmitEmployeeStage2() {
    this.isSubmit = true;
    console.log("121", this.CcpsStage1Form.value);
    console.log("121", this.CcpsStage1Form);
    
    // Check if we're in hiring flow and "No" is selected for CNSS or CNAMGS
    const isHiringFlow = !this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow && this.employeeWithCcpsStage1;
    
    if (isHiringFlow) {
      // Check if CNSS "No" is selected
      if (this.g.is_registered_cnss.value === 'no') {
        // Hide the hiring form
        this.employeeWithCcpsStage1 = false;
        // Set modal properties for CNSS message
        this.isSuccessModal = false;
        this.modalHeading = 'OOPS !';
        this.modalDescription = 'Employee registration cannot proceed without CNSS number. Please register with CNSS first.';
        // Reset flag
        this.hideFormSectionsOnNo = false;
        // Open the modal
        setTimeout(() => {
          $('#companyNotFoundModal').modal('show');
        }, 100);
        return;
      }
      
      // Check if CNAMGS "No" is selected
      if (this.g.is_registered_cnamgs.value === 'no') {
        // Hide the hiring form
        this.employeeWithCcpsStage1 = false;
        // Set modal properties for CNAMGS message
        this.isSuccessModal = false;
        this.modalHeading = 'OOPS !';
        this.modalDescription = 'Employee registration cannot proceed without CNAMGS number. Please register with CNAMGS first.';
        // Reset flag
        this.hideFormSectionsOnNo = false;
        // Open the modal
        setTimeout(() => {
          $('#companyNotFoundModal').modal('show');
        }, 100);
        return;
      }
    }
    
    if ((this.g.is_registered_cnamgs.value === 'no' && this.g.is_registered_cnss.value !== 'no') || this.isCnamgsEmployeeRegistrationFlow) {
      // Apply validations for CNAMGS Registration form (hiring flow CNAMGS "No" or CNAMGS registration from menu)
      this.applyCnamgsNoFormValidation();
      if (this.employeeHasNoId) {
        this.applyNoIdValidators();
      }
      // Mark all fields as touched to show validation errors
      this.CcpsStage1Form.markAllAsTouched();

      // Check form validity for CNAMGS Registration fields
      const employeePhotoControl = this.CcpsStage1Form.get('employee_Photo');
      const genderControl = this.CcpsStage1Form.get('gender');
      const idTypeControl = this.CcpsStage1Form.get('id_type');
      const dobControl = this.CcpsStage1Form.get('dob');
      const regionControl = this.CcpsStage1Form.get('region');
      const cityControl = this.CcpsStage1Form.get('city');
      const districtControl = this.CcpsStage1Form.get('district');
      const neighborhoodControl = this.CcpsStage1Form.get('neighborhood');
      const birthRegionControl = this.CcpsStage1Form.get('birth_region');
      const birthCityControl = this.CcpsStage1Form.get('birth_city');
      const birthDistrictControl = this.CcpsStage1Form.get('birth_district');
      const birthNeighborhoodControl = this.CcpsStage1Form.get('birth_neighborhood');
      const emailControl = this.CcpsStage1Form.get('email');
      const mobileControl = this.CcpsStage1Form.get('mobile');
      const maritalStatusControl = this.CcpsStage1Form.get('marital_status');
      const maritalStatusOtherControl = this.CcpsStage1Form.get('marital_status_other');
      // const administrativeStatusPublicControl = this.CcpsStage1Form.get('administrative_status_public');
      const administrativeStatusPrivateControl = this.CcpsStage1Form.get('administrative_status_private');
      // const joindateControl = this.CcpsStage1Form.get('joindate');
      // const affiliationTypeControl = this.CcpsStage1Form.get('affiliation_type');

      // Check if any required field is invalid
      let isInvalid =
        (employeePhotoControl && employeePhotoControl.invalid) ||
        (genderControl && genderControl.invalid) ||
        (idTypeControl && idTypeControl.invalid) ||
        (dobControl && dobControl.invalid) ||
        (regionControl && regionControl.invalid) ||
        (birthRegionControl && birthRegionControl.invalid) ||
        (cityControl && cityControl.invalid) ||
        (neighborhoodControl && neighborhoodControl.invalid) ||
        (emailControl && emailControl.invalid) ||
        (mobileControl && mobileControl.invalid) ||
        (maritalStatusControl && maritalStatusControl.invalid) ||
        (administrativeStatusPrivateControl && administrativeStatusPrivateControl.invalid);
        // (administrativeStatusPublicControl && administrativeStatusPublicControl.invalid) ||
        // (joindateControl && joindateControl.invalid);
      if (this.employeeHasNoId) {
        const firstNameControl = this.CcpsStage1Form.get('first_name');
        const lastNameControl = this.CcpsStage1Form.get('last_name');
        if ((firstNameControl && firstNameControl.invalid) || (lastNameControl && lastNameControl.invalid)) {
          isInvalid = true;
        }
      }

      if (isInvalid) {
        // Scroll to first invalid control
        this.scrollToFirstInvalidControl();
        return;
      }

      // Validation passed, now call API
      this.isSubmit = false;
      this.ngxUiLoaderService.start();

      const formValues = this.CcpsStage1Form.getRawValue();

      // Helper function to format date to dd/MM/yyyy
      const formatDateForAPI = (date: Date | string | null): string => {
        if (!date) return '';
        const d = new Date(date);
        if (isNaN(d.getTime())) return '';
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      };

      // Prepare data for API call - include all fields from CNAMGS Registration form
      const apiData = {
        image: formValues.employee_Photo,
        gender: formValues.gender,
        maiden_name: formValues.maiden_name,
        first_father_name: formValues.first_father_name,
        last_father_name: formValues.last_father_name,
        first_mother_name: formValues.first_mother_name,
        last_mother_name: formValues.last_mother_name,
        id_type: formValues.id_type,
        dob: formatDateForAPI(formValues.dob),
        birth_region: formValues.birth_region,
        birth_city: formValues.birth_city,
        birth_district: formValues.birth_district,
        birth_neighborhood: formValues.birth_neighborhood,
        region: formValues.region,
        city: formValues.city,
        district: formValues.district,
        neighborhood: formValues.neighborhood,
        email: formValues.email,
        post_box: formValues.post_box,
        mobile: formValues.mobile,
        marital_status: formValues.marital_status,
        marital_status_other: formValues.marital_status_other,
        marriage_date: formatDateForAPI(formValues.marriage_date),
        // administrative_status_public: formValues.administrative_status_public,
        administrative_status_private: formValues.administrative_status_private,
        // administration_code: formValues.administration_code,
        // joindate: formatDateForAPI(formValues.joindate),
        // category_public: formValues.category_public,
        category_private: formValues.category_private,
        // affiliation_type: formValues.affiliation_type,
        // employee_id: formValues.employee_id,
        // index: formValues.index,
        // grade: formValues.grade,
        employment_start_date: formatDateForAPI(formValues.employment_start_date),
        nature_of_activity: formValues.nature_of_activity,
        employer_organization_id: formValues.employer_organization_id,
        employee_id_employer: formValues.employee_id_employer,
        id_proof: formValues.id_proof,
        employee_birth_certificate_cnamgs: formValues.employee_birth_certificate_cnamgs,
        marriage_certificate_cnamgs: formValues.marriage_certificate_cnamgs,
        spouse_birth_certificate_cnamgs: formValues.spouse_birth_certificate_cnamgs,
        payslips: formValues.payslips,
        entity_type: '3',
        nip_number: this.employeeHasNoId ? null : this.employeeNipNumber,
        ...(this.employeeHasNoId && {
          is_nip_number: false,
          first_name: formValues.first_name || '',
          last_name: formValues.last_name || ''
        })
      };
      console.log("apiData", apiData)
      console.log("employeeNifNumber value:", this.employeeNifNumber)
      this.api.getHiringData(apiData).pipe(first())
        .subscribe(
          (data: any) => {
            this.response = data;
            this.ngxUiLoaderService.stop();
            if (this.response.status == 200) {
              this.employeespendingList = this.response.results;
              this.idArray = this.response.results.map(employee => employee.uuid);
              // this.pendingEmployeeCount = this.response.results.length.toString();
              this.isFromNoCnamgsRegistration = true;
              // Hide the form and show the modal
              this.employeeWithCcpsStage1 = false;
              this.snackBar.open(this.response.message, "ok", {
                duration: 2000,
              });
              setTimeout(() => {
                $('#allEmployeeModal').modal('show');
              }, 300);
            } else {
              this.snackBar.open(this.response.message, "ok", {
                duration: 2000,
              });
            }
          },
          (error: any) => {
            this.ngxUiLoaderService.stop();
            console.error('Error calling getCnamgsData:', error);

          }
        );
      return;
    }

    // IMPORTANT: Only show modal when submitting the CNAMGS "Yes" Additional Form (lines 506-626)
    // NOT when clicking "Next" in the CNAMGS Registration section
    // The check ensures: CNAMGS question is shown, "Yes" is selected, AND the additional form is already displayed
    // This check must be at the very beginning to prevent any other code from executing when submitting the form at 506-626
    // NOTE: The modal is now handled by showModalCNAMGS() function called directly from the submit button
    if (this.showCNAMGSQuestion && this.g.is_registered_cnamgs.value === 'yes' && this.showCnamgsYesForm) {
      // This means we're submitting the form at 506-626
      // The modal is now handled by showModalCNAMGS() function, so we just return here
      this.isSubmit = false;
      return;
    }

    // If CNAMGS "Yes" is selected but the additional form is NOT yet shown,
    // this means we're clicking "Next" in the CNAMGS Registration section
    // In this case, show loading, then show the form (506-626) and scroll to it
    // This check must happen early to prevent any modal from showing
    if (this.showCNAMGSQuestion && this.g.is_registered_cnamgs.value === 'yes' && !this.showCnamgsYesForm) {
      // Show loading
      this.ngxUiLoaderService.start();

      // Get CNAMGS value from form data and set it in control if needed
      const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
      const formData = this.CcpsStage1Form.getRawValue();
      if (formData.cnamgs && cnamgsControl && !cnamgsControl.value) {
        cnamgsControl.setValue(formData.cnamgs);
      }

      // Populate Form 1 (CNAMGS Yes form) fields from employeeData if available
      // Only populate if form hasn't been initialized yet (first time showing the form)
      if (this.employeeData && !this.formInitialized) {
        this.setCnamgsYesFormValues();
      }

      // Show the additional form without validation
      this.isSubmit = false;
      this.showCnamgsYesForm = true;
      // Apply validators for the additional form fields
      this.applyCnamgsYesFormValidation();

      // Wait for DOM update, then scroll to Employee Details form and stop loading
      setTimeout(() => {
        const employeeDetailsSection = document.getElementById('cnamgs-yes-form-section');
        if (employeeDetailsSection) {
          employeeDetailsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.ngxUiLoaderService.stop();
      }, 500);
      return;
    }

    var data = this.CcpsStage1Form.getRawValue();
    // Clear other_qualification if education_level is not '13' (handle both string and number)
    if (String(data.employee_education_level) !== '13') {
      data.other_qualification = '';
    }
    data['dob'] = this.g.dob.value;
    delete data['imageFile'];
    console.log("461", data)
    if (data && data.dob) {
      const dobDate = new Date(data.dob);
      if (!isNaN(dobDate.getTime())) {
        console.log(data['dob'])
        data['dob'] = this.datePipe.transform(dobDate, 'dd-MM-yyyy');
        console.log(data['dob'])
      } else {
        console.log(data['dob'])
        console.error('Invalid date format');
      }
    } else {
      console.error('No date provided');
    }
    if (data && data.joindate) {
      const joindate = new Date(data.joindate);
      if (!isNaN(joindate.getTime())) {
        console.log(data['joindate'])
        data['joindate'] = this.datePipe.transform(joindate, 'dd-MM-yyyy');
        console.log(data['joindate'])
        //data['joindate'] = this.convertOwl(editedDate)
      } else {
        console.log(data['joindate'])
        console.error('Invalid date format');
      }
    } else {
      console.error('No date provided');
    }




    console.log(data, '15554154155541');

    // Capture marital_status value early before any validation methods that might clear it
    const capturedMaritalStatus = data.marital_status;
    const capturedMaritalStatusOther = data.marital_status_other;
    // Apply validation based on CNSS registration status before checking form validity
    // Skip when in CNSS/CNAMGS registration flow from menu so we don't clear first_name/last_name validators (no-ID flow)
    const isRegisteredCnssValue = this.g.is_registered_cnss.value;
    if (isRegisteredCnssValue && !this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow) {
      this.applyCNSSRegistrationValidation(isRegisteredCnssValue);
    }

    // If CNSS "Yes" is selected and CNAMGS question is not shown yet, only validate CNSS field (hiring flow only)
    if (isRegisteredCnssValue === 'yes' && !this.showCNAMGSQuestion && !this.isCnssEmployeeRegistrationFlow) {
      // Only check CNSS field validity
      if (this.g.cnss.invalid) {
        this.scrollToFirstInvalidControl();
        return;
      }
      // If CNSS is valid, show CNAMGS question and update URL
      this.showCNAMGSQuestion = true;
      // Query parameters removed - no longer needed
      this.isSubmit = false;
      return;
    }

    if ((isRegisteredCnssValue === 'no' && !this.showCNAMGSQuestion) || this.isCnssEmployeeRegistrationFlow) {
      // Hide CNAMGS Verification section when CNSS "No" is selected (or CNSS registration from menu)
      if (!this.isCnssEmployeeRegistrationFlow) {
        this.showCNAMGSQuestion = false;
        this.showCnamgsYesForm = false;
      }

      // Populate common fields from employeeData when Form 3 (CNSS Registration) becomes visible
      // This happens when user switches from Form 2 (CNAMGS Registration) to Form 3
      // Only populate if form hasn't been initialized yet (first time showing the form)
      if (this.employeeData && !this.formInitialized) {
        this.setCommonFormFields();
      }

      this.applyCnssNoFormValidation();
      if (this.employeeHasNoId) {
        this.applyNoIdValidators();
      }
      this.CcpsStage1Form.markAllAsTouched();

      const genderControl = this.CcpsStage1Form.get('gender');
      const dobControl = this.CcpsStage1Form.get('dob');
      const nationalityControl = this.CcpsStage1Form.get('nationality');
      const idTypeControl = this.CcpsStage1Form.get('id_type');
      const mobileControl = this.CcpsStage1Form.get('mobile');
      const emailControl = this.CcpsStage1Form.get('email');
      const professionalCategoryControl = this.CcpsStage1Form.get('professional_category');
      const employeeTypeControl = this.CcpsStage1Form.get('employee_type');
      const joindateControl = this.CcpsStage1Form.get('joindate');
      const idFrontPhotoControl = this.CcpsStage1Form.get('id_Front_Photo');
      const professionalCategoryOtherControl = this.CcpsStage1Form.get('professional_category_other');
      const employeeTypeOtherControl = this.CcpsStage1Form.get('employee_type_other');
      const maritalStatusControl = this.CcpsStage1Form.get('marital_status');
      const maritalStatusOtherControl = this.CcpsStage1Form.get('marital_status_other');

      let isInvalid =
        (genderControl && genderControl.invalid) ||
        (dobControl && dobControl.invalid) ||
        (nationalityControl && nationalityControl.invalid) ||
        (idTypeControl && idTypeControl.invalid) ||
        (mobileControl && mobileControl.invalid) ||
        (emailControl && emailControl.invalid) ||
        (professionalCategoryControl && professionalCategoryControl.invalid) ||
        (employeeTypeControl && employeeTypeControl.invalid) ||
        (joindateControl && joindateControl.invalid) ||
        (idFrontPhotoControl && idFrontPhotoControl.invalid) ||
        (maritalStatusControl && maritalStatusControl.invalid);

      if (this.employeeHasNoId) {
        const firstNameControl = this.CcpsStage1Form.get('first_name');
        const lastNameControl = this.CcpsStage1Form.get('last_name');
        if ((firstNameControl && firstNameControl.invalid) || (lastNameControl && lastNameControl.invalid)) {
          isInvalid = true;
        }
      }
      if (professionalCategoryControl && professionalCategoryControl.value == '7' && professionalCategoryOtherControl && professionalCategoryOtherControl.invalid) {
        isInvalid = true;
      }
      if (maritalStatusControl && maritalStatusControl.value == '1' && maritalStatusOtherControl && maritalStatusOtherControl.invalid) {
        isInvalid = true;
      }
      if (employeeTypeControl && employeeTypeControl.value == '7' && employeeTypeOtherControl && employeeTypeOtherControl.invalid) {
        isInvalid = true;
      }

      if (isInvalid) {
        // Scroll to first invalid control
        this.scrollToFirstInvalidControl();
        return;
      }

      // Validation passed, now call API
      this.isSubmit = false;
      this.ngxUiLoaderService.start();

      // Get form values for API call
      const formValues = this.CcpsStage1Form.getRawValue();

      // Use captured marital_status value (captured early before validation methods)
      // Fallback to control value or formValues if captured value is not available
      const maritalStatusValue = capturedMaritalStatus || (maritalStatusControl ? maritalStatusControl.value : formValues.marital_status);
      const maritalStatusOtherValue = capturedMaritalStatusOther || (maritalStatusOtherControl ? maritalStatusOtherControl.value : formValues.marital_status_other);
      // Helper function to format date to dd/MM/yyyy
      const formatDateForAPI = (date: Date | string | null): string => {
        if (!date) return '';
        const d = new Date(date);
        if (isNaN(d.getTime())) return '';
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      };

      // Prepare data for API call - include all fields from CNSS Registration form
      const apiData = {
        gender: formValues.gender,
        maiden_name: formValues.maiden_name,
        dob: formatDateForAPI(formValues.dob),
        nationality: formValues.nationality,
        birthplace: formValues.birthplace,
        birth_region: formValues.birth_region,
        birth_city: formValues.birth_city,
        birth_district: formValues.birth_district,
        birth_neighborhood: formValues.birth_neighborhood,
        birth_certificate_number: formValues.birth_certificate_number,
        birth_certificate_issue_date: formatDateForAPI(formValues.birth_certificate_issue_date),
        marital_status: maritalStatusValue,
        marital_status_other: maritalStatusOtherValue,
        id_type: formValues.id_type,
        id_number: formValues.id_number,
        id_proof_expiry_date: formatDateForAPI(formValues.id_proof_expiry_date),
        mobile: formValues.mobile,
        email: formValues.email,
        professional_category: formValues.professional_category,
        professional_category_other: formValues.professional_category_other,
        employee_type: formValues.employee_type,
        employee_type_other: formValues.employee_type_other,
        position: formValues.position,
        joindate: formatDateForAPI(formValues.joindate),
        hiring_certificate_date: formatDateForAPI(formValues.hiring_certificate_date),
        id_proof: formValues.id_Front_Photo,
        employee_birth_certificate_cnamgs: formValues.birth_certificate_file,
        marriage_certificate_cnamgs: formValues.marriage_certificate_file,
        entity_type: '2',
        nip_number: this.employeeHasNoId ? null : this.employeeNipNumber,
        ...(this.employeeHasNoId && {
          is_nip_number: false,
          first_name: formValues.first_name || '',
          last_name: formValues.last_name || ''
        })
      };

      // Call getCnssData API
      this.api.getHiringData(apiData).pipe(first())
        .subscribe(
          (data: any) => {
            this.response = data;
            this.ngxUiLoaderService.stop();
            if (this.response.status == 200) {
              this.employeespendingList = this.response.results;
              this.idArray = this.response.results.map(employee => employee.uuid);
              // this.pendingEmployeeCount = this.response.results.length.toString();
              this.isFromNoCnssRegistration = true;
              this.employeeWithCcpsStage1 = false;
              this.snackBar.open(this.response.message, "ok", {
                duration: 2000,
              });
              setTimeout(() => {
                $('#allEmployeeModal').modal('show');
              }, 300);
            } else {
              this.snackBar.open(this.response.message, "ok", {
                duration: 2000000,
              });
            }
          },
          (error: any) => {
            this.ngxUiLoaderService.stop();
            console.error('Error calling getCnssData:', error);
            // Handle error - you may want to show an error message to the user
          }
        );
      return;
    }

    // If CNAMGS question is shown, check validation (but don't apply validation that might clear values)
    // Only validate CNAMGS field if "Yes" is selected and we're checking before showing additional form
    if (this.showCNAMGSQuestion && this.g.is_registered_cnamgs.value === 'yes' && !this.showCnamgsYesForm) {
      // Ensure CNAMGS field has required validator without clearing the value
      const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
      if (cnamgsControl) {
        const currentValue = cnamgsControl.value;
        // Clear validators
        cnamgsControl.clearValidators();
        cnamgsControl.updateValueAndValidity();
        // Ensure value is preserved
        if (currentValue && cnamgsControl.value !== currentValue) {
          cnamgsControl.setValue(currentValue);
          cnamgsControl.updateValueAndValidity();
        }
      }
    }

    // Check form validity - but handle CNAMGS "Yes" case separately
    // Skip validation entirely when CNAMGS "Yes" form is shown (to show modal directly without validation)
    if (!(this.showCNAMGSQuestion && this.g.is_registered_cnamgs.value === 'yes' && this.showCnamgsYesForm)) {
      // If CNAMGS "Yes" is selected and form is not yet shown, we'll validate CNAMGS field later
      // Don't block here for CNAMGS "Yes" case - let it proceed to show additional form
      if (!(this.showCNAMGSQuestion && this.g.is_registered_cnamgs.value === 'yes' && !this.showCnamgsYesForm)) {
        // For all other cases, check form validity normally
        if (this.CcpsStage1Form.invalid) {
          // Log invalid controls for debugging
          Object.keys(this.CcpsStage1Form.controls).forEach(key => {
            const control = this.CcpsStage1Form.get(key);
            if (control && control.invalid) {
              console.log('Invalid control:', key, control.errors);
            }
          });
          this.scrollToFirstInvalidControl()
          return;
        }
      }
    }
    if (!this.resubmit && !this.employeeBeforeSubmit) {
      console.log(this.ccpsId)
      if (this.ccpsId) {
        // data['ccpsid'] = this.ccpsId;
        data['ccpsid'] = null;
        console.log("484", data.ccpsid)
      } else {
        // For new employees without CCPS ID, set to null
        // this.f.ccpsid.value comes from withCcpsForm which is only used for CCPS ID lookup
        const ccpsIdFromForm = this.f.ccpsid.value;
        data['ccpsid'] = ccpsIdFromForm || null;
        console.log("487", data.ccpsid)
      }

      console.log("271", data.ccpsid)
      console.log("ddddddddddddddddddd", data)
      data['base_salary'] = '100000';
      delete data.month;
      delete data.amount;
      // Keep year in the payload for submission
      console.log("eeeeeeeeeeeeeeeeeeeeeeeeee", data)

      console.log("fffffffffffffffffffffffffffffffff", this.salaryListByYear)
      // Include salary details from addSalary() in the payload
      data['salary'] = this.formatSalaryForPayload();
      console.log(data, 'salary data payload');

      // If "Yes" is selected, show CNAMGS question after successful validation (first submit)
      if (this.g.is_registered_cnss.value === 'yes' && this.g.cnss.valid && !this.showCNAMGSQuestion) {
        this.showCNAMGSQuestion = true;
        // Don't proceed with API call yet - wait for CNAMGS selection
        this.isSubmit = false;
        return;
      }

      // If CNAMGS question is shown and CNAMGS is selected, handle accordingly
      if (this.showCNAMGSQuestion && this.g.is_registered_cnamgs.value) {
        // If CNAMGS "No" is selected, validate first, then show modal
        if (this.g.is_registered_cnamgs.value === 'no') {
          this.applyCnamgsNoFormValidation();
          this.CcpsStage1Form.markAllAsTouched();

          const employeePhotoControl = this.CcpsStage1Form.get('employee_Photo');
          const genderControl = this.CcpsStage1Form.get('gender');
          const idTypeControl = this.CcpsStage1Form.get('id_type');
          const dobControl = this.CcpsStage1Form.get('dob');
          const regionControl = this.CcpsStage1Form.get('region');
          const cityControl = this.CcpsStage1Form.get('city');
          const districtControl = this.CcpsStage1Form.get('district');
          const neighborhoodControl = this.CcpsStage1Form.get('neighborhood');
          const birthRegionControl = this.CcpsStage1Form.get('birth_region');
          const birthCityControl = this.CcpsStage1Form.get('birth_city');
          const birthDistrictControl = this.CcpsStage1Form.get('birth_district');
          const birthNeighborhoodControl = this.CcpsStage1Form.get('birth_neighborhood');
          const emailControl = this.CcpsStage1Form.get('email');
          const mobileControl = this.CcpsStage1Form.get('mobile');
          const maritalStatusControl = this.CcpsStage1Form.get('marital_status');
          const maritalStatusOtherControl = this.CcpsStage1Form.get('marital_status_other');
          // const administrativeStatusPublicControl = this.CcpsStage1Form.get('administrative_status_public');
          const administrativeStatusPrivateControl = this.CcpsStage1Form.get('administrative_status_private');
          // const joindateControl = this.CcpsStage1Form.get('joindate');
          // const affiliationTypeControl = this.CcpsStage1Form.get('affiliation_type');

          const isInvalid =
            (employeePhotoControl && employeePhotoControl.invalid) ||
            (genderControl && genderControl.invalid) ||
            (idTypeControl && idTypeControl.invalid) ||
            (dobControl && dobControl.invalid) ||
            (regionControl && regionControl.invalid) ||
            (birthRegionControl && birthRegionControl.invalid) ||
            (cityControl && cityControl.invalid) ||
            (neighborhoodControl && neighborhoodControl.invalid) ||
            (emailControl && emailControl.invalid) ||
            (mobileControl && mobileControl.invalid) ||
            (maritalStatusControl && maritalStatusControl.invalid) ||
            (administrativeStatusPrivateControl && administrativeStatusPrivateControl.invalid);
            // (administrativeStatusPublicControl && administrativeStatusPublicControl.invalid) ||
            // (joindateControl && joindateControl.invalid)
          // (affiliationTypeControl && affiliationTypeControl.invalid);

          if (isInvalid) {
            // Scroll to first invalid control
            this.scrollToFirstInvalidControl();
            return;
          }

          // Form is valid, proceed to show modal
          this.isSubmit = false;
          this.employeespendingList = this.response.results;
          this.idArray = this.response.results.map(employee => employee.uuid);
          // this.pendingEmployeeCount = this.response.results.length.toString();
          this.isFromNoCnamgsRegistration = true;

          // Hide the form and show the modal
          this.employeeWithCcpsStage1 = false;
          setTimeout(() => {
            $('#allEmployeeModal').modal('show');
          }, 300);
          return;
        }
        // If CNAMGS "Yes" is selected and form is not yet shown, show the additional form (skip validation)
        if (this.g.is_registered_cnamgs.value === 'yes' && !this.showCnamgsYesForm) {
          // Get CNAMGS value from form data and set it in control if needed
          const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
          if (data.cnamgs && cnamgsControl && !cnamgsControl.value) {
            cnamgsControl.setValue(data.cnamgs);
          }

          // Show the additional form without validation
          this.isSubmit = false;
          this.showCnamgsYesForm = true;
          // Apply validators for the additional form fields
          this.applyCnamgsYesFormValidation();
          return;
        }
      }

      // If "Yes" is selected, proceed with API call
      this.ngxUiLoaderService.start();
      this.api.employeeDetails(data).pipe(first())
        .subscribe(data => {
          this.isSubmit = false;
          this.ngxUiLoaderService.stop();
          this.responseemployee = data
          if (this.responseemployee.status == 200) {
            this.isFromNoCnssRegistration = false;
            this.resetFields();
            this.getEmployeeList(2);
          } else {
            this.snackBar.open(this.responseemployee.message, "OK", {
              duration: 5000,
            });
          }

        },
          error => {
            this.isSubmit = false;
            this.ngxUiLoaderService.stop();
          });
    } else if (this.resubmit && !this.employeeBeforeSubmit) {
      data['employee_id'] = this.id;
      if (this.ccpsId) {
        data['ccpsid'] = this.ccpsId;
      } else {
        data['ccpsid'] = null;
      }
      console.log("516", data.ccpsid)

      // Include salary details for resubmit
      data['base_salary'] = '100000';
      delete data.month;
      delete data.amount;
      // Keep year in the payload for submission
      data['salary'] = this.formatSalaryForPayload();

      this.ngxUiLoaderService.start();
      this.api.employeeResubmit(data).pipe(first())
        .subscribe(data => {
          console.log("320", data)
          this.isSubmit = false;
          this.ngxUiLoaderService.stop();
          this.responseemployee = data
          if (this.responseemployee.status == 200) {
            this.getEmployeeList(2);
            this.employeeWithCcpsStage1 = false;
            this.resubmit = false;
          } else { }
          this.snackBar.open(this.responseemployee.message, "OK", {
            duration: 5000,
          });
        },
          error => {
            this.isSubmit = false;
            this.ngxUiLoaderService.stop();
          });
    } else if (this.employeeBeforeSubmit) {
      console.log(data);
      data['employee_id'] = this.id;
      if (this.ccpsId) {
        data['ccpsid'] = this.ccpsId;
      } else {
        data['ccpsid'] = null;
      }

      // Include salary details for edit before submit
      data['base_salary'] = '100000';
      delete data.month;
      delete data.amount;
      // Keep year in the payload for submission
      data['salary'] = this.formatSalaryForPayload();

      this.ngxUiLoaderService.start();
      this.api.employeeEditBeforeSubmit(data).pipe(first())
        .subscribe(data => {
          console.log("528", data)
          this.isSubmit = false;
          this.ngxUiLoaderService.stop();
          this.responseemployee = data
          if (this.responseemployee.status == 200) {
            this.getEmployeeList(2);
            this.employeeWithCcpsStage1 = false;
            this.employeeBeforeSubmit = false;
          } else { }
          this.snackBar.open(this.responseemployee.message, "OK", {
            duration: 5000,
          });
        },
          error => {
            this.isSubmit = false;
            this.ngxUiLoaderService.stop();
          });

      // $('#employeeWithCcpsStage1').modal('hide');

    }
  }
  bulkUpload(event: any, id): void {
    console.log("2250", event)
    console.log("2251", event.target.files[0])
    const fileNameDisplay = document.getElementById(id);
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log('uploaded image: ', file)
      const filename = file.name;
      var ext = filename.split('.').pop().toLowerCase();
      console.log("304", ext)
      if (file.size > 5242880) {

        if (this.currentLang == 'fr') {
          alert('La taille du fichier doit être inférieure à 5MB')
        } else {
          alert('File Size should be less than 5MB')
        }
        return;
      }
      if (ext != 'csv' && ext != 'xlsx' && ext != 'xls') {
        console.log("295")
        if (this.currentLang == 'fr') {
          alert('Type de fichier non autorisé. Les types de fichier autorisés sont .csv, .xlsx, .xls')
        } else {
          alert('File type not allowed. Allowed file types are  .csv, .xlsx, .xls')
        }
        return;
      }
      console.log("303")
      this.ngxUiLoaderService.start();
      const target = event.target.dataset.target;
      console.log(event)
      const formData = new FormData();
      formData.append('csvFile', file);
      formData.append('year', this.selectedBulkUploadYear);
      formData.append('quarter', this.selectedBulkUploadQuarter);
      console.log("308", formData)
      formData['encrypt_mode'] = false;
      $('#bulkUpload').modal('hide');

      // setTimeout(() => {
      //   $('#bulkUploadSuccesssModal').modal('show');
      //   this.EmpolyeeBulkUploadForm.reset();
      //   this.ngxUiLoaderService.stop();
      // }, 500)

      this.api.employeesBulkUpload(formData).pipe(first())
        .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.EmpolyeeBulkUploadForm.reset();
            console.log("351", this.bulkUploadDetails = this.response)
            this.bulkUploadSuccess = this.response.successData
            this.bulkUploadFailed = this.response.failedData
            if (this.bulkUploadFailed !== undefined && this.bulkUploadFailed !== null && this.bulkUploadFailed.length > 0) {
              this.showFailedTitle = true;
            }
            if (this.bulkUploadSuccess !== undefined && this.bulkUploadSuccess !== null && this.bulkUploadSuccess.length > 0) {
              this.showSuccessTitle = true
            }
            $('#bulkUpload').modal('hide');

            setTimeout(() => {
              $('#bulkUploadSuccesssModal').modal('show');
            }, 500)

            // this.router.navigate(['/dashboard']);
            // this.snackBar.open(data.message, "OK", {
            //   duration: 5000,
            // });
          } else {
            // $('#bulkUpload').modal('hide');
            this.EmpolyeeBulkUploadForm.reset();
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }

        },
          error => { });

    }
  }

  upload(event: any, id): void {
    console.log("2250", event)
    console.log("597 id :", id)
    console.log("2251", event.target.files[0])

    if (event.target.files.length > 0) {

      const file = event.target.files[0];
      console.log('uploaded image: ', file)
      const filename = file.name;
      var ext = filename.split('.').pop();
      if (file.size > 5242880) {

        if (this.currentLang == 'fr') {
          alert('La taille du fichier doit être inférieure à 5MB')
        } else {
          alert('File Size should be less than 5MB')
        }
        return;
      }
      if (id == 'employeePhoto') {
        console.log("541  Employee Photo")
        if (ext != 'jpg' && ext != 'JPG' && ext != 'png' && ext != 'PNG' && ext != 'JPEG' && ext != 'jpeg' && ext != 'bmp' && ext != 'BMP' && ext != 'webp' && ext != 'heic' && ext != 'HEIC' && ext != 'heif' && ext != 'HEIF' && ext != 'tiff' && ext != 'TIFF' && ext != 'tif' && ext != 'TIF') {
          if (this.currentLang == 'fr') {
            alert('Type de fichier non autorisé. Les types de fichier autorisés sont  .jpg .png .jpeg .bmp .webp .heic .heif .tiff')
          } else {
            alert('File type not allowed. Allowed file types are .jpg .png .jpeg .bmp .webp .heic .heif .tiff')
          }
          return;
        }
      } else {
        console.log("pdf allowed")
        if (ext != 'jpg' && ext != 'JPG' && ext != 'png' && ext != 'PNG' && ext != 'JPEG' && ext != 'jpeg' && ext != 'pdf' && ext != 'PDF' && ext != 'doc' && ext != "Doc" && ext != 'docx' && ext != 'DOCX' && ext != 'bmp' && ext != 'BMP' && ext != 'webp' && ext != 'heic' && ext != 'HEIC' && ext != 'heif' && ext != 'HEIF' && ext != 'tiff' && ext != 'TIFF' && ext != 'tif' && ext != 'TIF') {
          if (this.currentLang == 'fr') {
            alert('Type de fichier non autorisé. Les types de fichier autorisés sont .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
          } else {
            alert('File type not allowed. Allowed file types are .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
          }
          return;
        }
      }
      this.ngxUiLoaderService.start();
      const target = event.target.dataset.target;
      console.log(target)
      const formData = new FormData();
      formData.append('image', file);
      formData.append('target', target);
      console.log("file is :", file)
      console.log("target is :", target)
      console.log("607", formData)
      formData['encrypt_mode'] = false;
      // formData.append('uuid', this.businessData.business_code);
      this.api.upload(formData).pipe(first())
        .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.responseupload = data;
          if (this.responseupload.status == 200) {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
            // const fileNameDisplay = document.getElementById(showView);
            // console.log("659", fileNameDisplay)
            // if (this.currentLang == 'fr') {
            //   fileNameDisplay.textContent = `Cliquez pour voir le fichier`;
            // } else {
            //   console.log("file name to display", fileNameDisplay.textContent)
            //   if (id == 'bulkUpload') {
            //     $('#bulkUpload').modal('hide');
            //     this.employeeList = false;
            //   } else {
            //     fileNameDisplay.textContent = `Click to view File`;
            //   }
            // }
            if (target == 'employee_Photo') {
              this.CcpsStage1Form.get('employee_Photo').setValue(this.responseupload.results.file);
              this.employee_Photo = this.responseupload.results.imageUrl;
            }
            if (target == 'id_Front_Photo') {
              this.CcpsStage1Form.get('id_Front_Photo').setValue(this.responseupload.results.file);
              this.id_Front_Photo = this.responseupload.results.imageUrl;
            }
            if (target == 'resign_reason_document') {
              this.resignationForm.get('resign_reason_document').setValue(this.responseupload.results.file);
              this.resign_reason_document = this.responseupload.results.imageUrl;
              console.log("image url", this.resign_reason_document)
            }
            if (target == 'spouse_birth_certificate') {
              this.CcpsStage1Form.get('spouse_birth_certificate').setValue(this.responseupload.results.file);
              this.spouse_birthCertificate_url = this.responseupload.results.imageUrl;
              console.log("image url", this.spouse_birthCertificate_url)
              console.log("image url", this.spouse_birthCertificate_url)
            }
            if (target == 'spouse_certificate') {
              this.CcpsStage1Form.get('spouse_certificate').setValue(this.responseupload.results.file);
              this.spouseCertificate_url = this.responseupload.results.imageUrl;
              console.log("image url", this.spouseCertificate_url)
            }
            if (target == 'id_proof') {
              this.CcpsStage1Form.get('id_proof').setValue(this.responseupload.results.file);
              this.id_proof_url = this.responseupload.results.imageUrl;
            }
            if (target == 'employee_birth_certificate_cnamgs') {
              this.CcpsStage1Form.get('employee_birth_certificate_cnamgs').setValue(this.responseupload.results.file);
              this.employee_birth_certificate_cnamgs_url = this.responseupload.results.imageUrl;
            }
            if (target == 'marriage_certificate_cnamgs') {
              this.CcpsStage1Form.get('marriage_certificate_cnamgs').setValue(this.responseupload.results.file);
              this.marriage_certificate_cnamgs_url = this.responseupload.results.imageUrl;
            }
            if (target == 'birth_certificate_file') {
              this.CcpsStage1Form.get('birth_certificate_file').setValue(this.responseupload.results.file);
              this.birth_certificate_file_url = this.responseupload.results.imageUrl;
            }
            if (target == 'marriage_certificate_file') {
              this.CcpsStage1Form.get('marriage_certificate_file').setValue(this.responseupload.results.file);
              this.marriage_certificate_file_url = this.responseupload.results.imageUrl;
            }
            if (target == 'spouse_birth_certificate_cnamgs') {
              this.CcpsStage1Form.get('spouse_birth_certificate_cnamgs').setValue(this.responseupload.results.file);
              this.spouse_birth_certificate_cnamgs_url = this.responseupload.results.imageUrl;
            }
            if (target == 'payslips') {
              this.CcpsStage1Form.get('payslips').setValue(this.responseupload.results.file);
              this.payslips_url = this.responseupload.results.imageUrl;
            }


          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
          error => {

          });



    }
  }

  submitEmployees() {
    console.log(this.idArray)
    if (this.idArray.length == 0) {
      return
    }
    var data = {
      employee_id: this.idArray
    }
    this.ngxUiLoaderService.start();
    this.api.updateEmployeewithID(data).pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();
        this.response = data;
        if (this.response.status == 200) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          $('#allEmployeeModal').modal('hide');
          console.log("modal hide at 494")
          this.employeeList = false;
          this.employeeWithCcpsStage1 = false;

          // Handle CNAMGS "Yes" registration flow
          if (this.isFromCnamgsYesRegistration) {
            // Reset flags
            this.isFromCnamgsYesRegistration = false;
            this.showCNAMGSQuestion = false;
            // Reset form
            this.resetFields();
            // Clear URL parameters
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {}
            });
            // Show success modal first, then refresh employee list without opening the "List of Employees to Add" modal
            setTimeout(() => {
              $('#addEmployeeSuccessModal').modal('show');
              // Refresh employee list after showing success modal (use 3 to prevent auto-opening the modal)
              setTimeout(() => {
                this.anpiService.emitEvent();
                // this.getEmployeeList(3);
              }, 500);
            }, 500);
          } else {
            // Delay emitEvent and getEmployeeList until after success modal is shown
            setTimeout(() => {
              $('#addEmployeeSuccessModal').modal('show');
              // Call emitEvent after showing success modal to prevent "List of Employees to Add" modal from opening
              setTimeout(() => {
                this.anpiService.emitEvent();
                // this.getEmployeeList(3); // Use 3 to prevent auto-opening the modal
              }, 500);
            }, 1000);
          }

        } else {
          this.snackBar.open(this.response.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  getEmployeeList(val) {
    console.log("515")
    this.ngxUiLoaderService.start();
    this.api.getEmployeeList().pipe(first())
      .subscribe(data => {

        this.ngxUiLoaderService.stop();
        this.responselist = data;
        console.log("586", this.responselist)
        if (this.responselist.status == 200) {
          if (val == 4) {
            this.anpiService.emitEvent();
          }
          this.employeesallList = this.responselist.result.results;
          this.searchList = this.responselist.result.results;

          if (this.employeesallList) {
            this.totalItems = this.employeesallList.length;
            if (this.employeesallList.length) {
              this.employeeList = false;
            }
          }
          this.employeespendingList = this.responselist.pending;
          this.pendingEmployeeCount = this.employeespendingList.length;
          if (this.employeespendingList.length != 0) {
            this.idArray = this.employeespendingList.map(item => item.uuid);
            console.log(this.idArray)
            // Don't auto-show modal on initial page load (val == 1) or when explicitly disabled (val == 3)
            if (val != 3 && val != 1) {
              $('#allEmployeeModal').modal('show');
            }
          }
        } else {
          // this.snackBar.open(this.responselist.message, "OK", {
          //   duration: 5000,
          // });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }
  // onMaritalStatusChange(value: any) {
  //   console.log("Selected value:", value);
  //   switch (value) {
  //     case '1':
  //       {
  //         console.log("829")
  //         this.g['spouse_birth_certificate'].setValue(null);
  //         this.g['spouse_birth_certificate'].setValidators([]);
  //         this.g['spouse_birth_certificate'].updateValueAndValidity();
  //         this.spouse_birthCertificate_url = null;
  //         break;
  //       }
  //     case '2':
  //     case '3':
  //     case '4':
  //     case '5':
  //       {
  //         console.log("840")
  //         this.g['spouse_birth_certificate'].setValue(null);
  //         this.g['spouse_birth_certificate'].clearValidators();
  //         this.g['spouse_birth_certificate'].updateValueAndValidity();
  //         this.spouse_birthCertificate_url = null;
  //         break;
  //       }
  //   }
  // }
  /**
   * Populate Form 1 (CNAMGS Yes form) specific fields
   * This form contains: Hiring Date, Hiring Certificate Date, Type of Contract, 
   * End Date, Professional Rank, Employee Type, Occupation/Position
   */
  setCnamgsYesFormValues() {
    if (!this.employeeData) return;

    // Format and set hiring date
    if (this.employeeData.joindate || this.employeeData.join_date) {
      const joinDate = this.employeeData.joindate || this.employeeData.join_date;
      if (joinDate) {
        const joinDateFormatted = new Date(joinDate);
        joinDateFormatted.setHours(0, 0, 0, 0);
        this.CcpsStage1Form.controls['joindate'].setValue(joinDateFormatted);
      }
    }

    // Set hiring certificate date if available
    if (this.employeeData.hiring_certificate_date) {
      const hiringCertDate = new Date(this.employeeData.hiring_certificate_date);
      hiringCertDate.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['hiring_certificate_date'].setValue(hiringCertDate);
    }

    // Set type of contract
    if (this.employeeData.contract_type || this.employeeData.type_of_contract) {
      const contractType = this.employeeData.contract_type || this.employeeData.type_of_contract;
      this.CcpsStage1Form.controls['type_of_contract'].setValue(contractType);
      // Trigger contract type change to handle end date validation
      this.onContractTypeChange(String(contractType));
    }

    // Set contract end date if contract type is 2
    if (this.employeeData.contract_end_date && (this.employeeData.contract_type == '2' || this.employeeData.type_of_contract == '2')) {
      const contractEndDate = new Date(this.employeeData.contract_end_date);
      contractEndDate.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['contract_end_date'].setValue(contractEndDate);
    }

    // Set professional rank
    if (this.employeeData.professional_rank) {
      this.CcpsStage1Form.controls['professional_rank'].setValue(this.employeeData.professional_rank);
    }

    // Set employee type
    if (this.employeeData.employee_type) {
      this.CcpsStage1Form.controls['employee_type'].setValue(this.employeeData.employee_type);
      this.selectedEmployeeType = String(this.employeeData.employee_type);
      // Trigger employee type change to handle other field validation
      this.onEmployeeTypeChange(String(this.employeeData.employee_type));
    }

    // Set employee type other if employee type is 7
    if (this.employeeData.employee_type_other && (this.employeeData.employee_type == '7')) {
      this.CcpsStage1Form.controls['employee_type_other'].setValue(this.employeeData.employee_type_other);
    }

    // Set position/occupation
    if (this.employeeData.position || this.employeeData.designation) {
      this.CcpsStage1Form.controls['position'].setValue(this.employeeData.position || this.employeeData.designation);
    }
  }

  /**
   * Populate common fields between Form 2 (CNAMGS Registration) and Form 3 (CNSS Registration)
   * Common fields include: Gender, DOB, Marital Status, ID Type, Phone, Email, etc.
   */
  setCommonFormFields() {
    if (!this.employeeData) return;

    // Gender
    if (this.employeeData.gender) {
      this.CcpsStage1Form.controls['gender'].setValue(this.employeeData.gender);
      this.employeeGender = String(this.employeeData.gender);
    }

    // Maiden name (if female)
    if (this.employeeData.maiden_name || this.employeeData.maiden) {
      this.CcpsStage1Form.controls['maiden_name'].setValue(this.employeeData.maiden_name || this.employeeData.maiden);
    }

    // Date of Birth
    if (this.employeeData.dob) {
      const dobFormatted = new Date(this.employeeData.dob);
      dobFormatted.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['dob'].setValue(dobFormatted);
    }

    // Marital Status
    if (this.employeeData.marital_status) {
      this.CcpsStage1Form.controls['marital_status'].setValue(this.employeeData.marital_status);
      this.selectedMaritalStatus = String(this.employeeData.marital_status);
    }

    // Marital Status Other
    if (this.employeeData.marital_status_other) {
      this.CcpsStage1Form.controls['marital_status_other'].setValue(this.employeeData.marital_status_other);
    }

    // Marriage Date
    if (this.employeeData.marriage_date) {
      const marriageDate = new Date(this.employeeData.marriage_date);
      marriageDate.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['marriage_date'].setValue(marriageDate);
    }

    // ID Type
    if (this.employeeData.id_type) {
      this.CcpsStage1Form.controls['id_type'].setValue(this.employeeData.id_type);
    }

    // ID Number
    if (this.employeeData.id_number) {
      this.CcpsStage1Form.controls['id_number'].setValue(this.employeeData.id_number);
    }

    // Phone Number
    if (this.employeeData.mobile) {
      this.CcpsStage1Form.controls['mobile'].setValue(this.employeeData.mobile);
    }

    // Email
    if (this.employeeData.email) {
      this.CcpsStage1Form.controls['email'].setValue(this.employeeData.email);
    }

    // Hiring Date (common to both forms)
    if (this.employeeData.joindate || this.employeeData.join_date) {
      const joinDate = this.employeeData.joindate || this.employeeData.join_date;
      if (joinDate) {
        const joinDateFormatted = new Date(joinDate);
        joinDateFormatted.setHours(0, 0, 0, 0);
        this.CcpsStage1Form.controls['joindate'].setValue(joinDateFormatted);
      }
    }

    // Hiring Certificate Date
    if (this.employeeData.hiring_certificate_date) {
      const hiringCertDate = new Date(this.employeeData.hiring_certificate_date);
      hiringCertDate.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['hiring_certificate_date'].setValue(hiringCertDate);
    }

    // Employee Type
    if (this.employeeData.employee_type) {
      this.CcpsStage1Form.controls['employee_type'].setValue(this.employeeData.employee_type);
      this.selectedEmployeeType = String(this.employeeData.employee_type);
      this.onEmployeeTypeChange(String(this.employeeData.employee_type));
    }

    // Employee Type Other
    if (this.employeeData.employee_type_other && (this.employeeData.employee_type == '7')) {
      this.CcpsStage1Form.controls['employee_type_other'].setValue(this.employeeData.employee_type_other);
    }

    // Position/Occupation
    if (this.employeeData.position || this.employeeData.designation) {
      this.CcpsStage1Form.controls['position'].setValue(this.employeeData.position || this.employeeData.designation);
    }

    // Professional Category (for CNSS form)
    if (this.employeeData.professional_category) {
      this.CcpsStage1Form.controls['professional_category'].setValue(this.employeeData.professional_category);
      this.selectedProfessionalCategory = String(this.employeeData.professional_category);
      this.onProfessionalCategoryChange(String(this.employeeData.professional_category));
    }

    // Professional Category Other
    if (this.employeeData.professional_category_other && (this.employeeData.professional_category == '7')) {
      this.CcpsStage1Form.controls['professional_category_other'].setValue(this.employeeData.professional_category_other);
    }
  }

  setEmployeeDetailsValues() {
    console.log(this.employeeData)
    this.ccpsId = this.employeeData.ccpsid;
    console.log(this.ccpsId)
    // Ensure NIF number is set from employeeData if available
    if (this.employeeData.nif_number) {
      this.employeeNifNumber = this.employeeData.nif_number;
    }
    this.CcpsStage1Form.controls['nip_number'].setValue(this.employeeData.nip_number);
    this.CcpsStage1Form.controls['first_name'].setValue(this.employeeData.first_name);
    this.CcpsStage1Form.controls['last_name'].setValue(this.employeeData.last_name);
    this.CcpsStage1Form.controls['maiden_name'].setValue(this.employeeData.maiden_name);
    this.CcpsStage1Form.controls['first_father_name'].setValue(this.employeeData.first_name_father);
    this.CcpsStage1Form.controls['last_father_name'].setValue(this.employeeData.last_name_father);
    this.CcpsStage1Form.controls['first_mother_name'].setValue(this.employeeData.first_name_mother);
    this.CcpsStage1Form.controls['last_mother_name'].setValue(this.employeeData.last_name_mother);
    this.CcpsStage1Form.controls['city'].setValue(this.employeeData.city);
    const dob_formatted = new Date(this.employeeData.dob)
    dob_formatted.setHours(0, 0, 0, 0);
    this.CcpsStage1Form.controls['dob'].setValue(dob_formatted);
    if (this.employeeData.dob && this.employeeData.ccps_status == 1) {
      this.maxDateOfBirth = null;
      console.log("292", this.maxDateOfBirth)
      // this.makeInputReadOnly();
    }
    this.CcpsStage1Form.controls['birthplace'].setValue(this.employeeData.birth_place);
    // this.CcpsStage1Form.controls['civil_status_document'].setValue(this.employeeData.civil_document);
    // this.CcpsStage1Form.controls['number_of_civil_status_document'].setValue(this.employeeData.number_of_civil);
    this.CcpsStage1Form.controls['birthcountry'].setValue(this.employeeData.birth_country);
    this.CcpsStage1Form.controls['gender'].setValue(this.employeeData.gender);
    this.CcpsStage1Form.controls['mobile'].setValue(this.employeeData.mobile);
    this.CcpsStage1Form.controls['post_box'].setValue(this.employeeData.post_box);
    this.CcpsStage1Form.controls['details_of_location'].setValue(this.employeeData.location);
    this.CcpsStage1Form.controls['employee_education_level'].setValue(this.employeeData.education_level);
    this.selectedEducationLevel = String(this.employeeData.education_level);
    if (String(this.employeeData.education_level) === '13') {
      if (this.employeeData.other_qualification) {
        this.CcpsStage1Form.controls['other_qualification'].setValue(this.employeeData.other_qualification);
      }
      // Clear validators for other_qualification
      this.CcpsStage1Form.controls['other_qualification'].clearValidators();
      this.CcpsStage1Form.controls['other_qualification'].updateValueAndValidity();
    } else {
      this.CcpsStage1Form.controls['other_qualification'].setValue('');
      this.CcpsStage1Form.controls['other_qualification'].clearValidators();
      this.CcpsStage1Form.controls['other_qualification'].updateValueAndValidity();
    }
    this.CcpsStage1Form.controls['address'].setValue(this.employeeData.address);
    // this.CcpsStage1Form.controls['company_id'].setValue(this.employeeData.company_id);
    this.CcpsStage1Form.controls['email'].setValue(this.employeeData.email);
    // Don't set CNSS value here for Hiring resubmit flow - it will be set conditionally based on is_cnss flag
    if (!(this.resubmit && !this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow && this.employeeWithCcpsStage1)) {
      this.CcpsStage1Form.controls['cnss'].setValue(this.employeeData.cnss);
    }
    if (this.employeeData.nationality) {
      this.CcpsStage1Form.controls['nationality'].setValue(this.employeeData.nationality);
      this.CcpsStage1Form.controls['id_type'].setValue(this.employeeData.id_type);
      if (this.employeeData.nationality != 77) {
        this.idTypeList();
      }
    }

    console.log(this.CcpsStage1Form.controls['id_type'].setValue(this.employeeData.id_type))
    console.log(this.employeeData.id_type)

    console.log("768", this.employeeData)
    this.CcpsStage1Form.controls['region'].setValue(this.employeeData.region);
    if (this.g.region.value) {
      const region = this.g.region.value;
      console.log("370", region)
      this.changeRegion(region);
      if (this.cityList) {
        this.CcpsStage1Form.controls['city'].setValue(this.employeeData.city);
      }
    }

    this.CcpsStage1Form.controls['city'].setValue(this.employeeData.city);
    if (this.g.city.value) {
      const city = this.g.city.value;
      console.log("370", city)
      this.changeCity(city);
      if (this.districtList) {
        this.CcpsStage1Form.controls['district'].setValue(this.employeeData.district);
      }
    }

    this.CcpsStage1Form.controls['district'].setValue(this.employeeData.district);
    if (this.g.district.value) {
      const district = this.g.district.value;
      console.log("370", district)
      this.changeDistrict(district);
      if (this.neighborhoodList) {
        this.CcpsStage1Form.controls['neighborhood'].setValue(this.employeeData.neighborhood);
      }
    }

    this.CcpsStage1Form.controls['neighborhood'].setValue(this.employeeData.neighborhood);
    this.CcpsStage1Form.controls['birth_region'].setValue(this.employeeData.birth_region);
    this.CcpsStage1Form.controls['birth_city'].setValue(this.employeeData.birth_city);
    this.CcpsStage1Form.controls['birth_district'].setValue(this.employeeData.birth_district);
    this.CcpsStage1Form.controls['birth_neighborhood'].setValue(this.employeeData.birth_neighborhood);
    if (this.employeeData.contract_type) {
      this.CcpsStage1Form.controls['type_of_contract'].setValue(this.employeeData.contract_type);
    }
 
    this.CcpsStage1Form.controls['marital_status'].setValue(this.employeeData.marital_status);
    this.CcpsStage1Form.controls['marital_status_other'].setValue(this.employeeData.marital_status_other);
    // Set selectedMaritalStatus to trigger the conditional display of marital_status_other field
    if (this.employeeData.marital_status) {
      this.selectedMaritalStatus = String(this.employeeData.marital_status);
    }
    this.CcpsStage1Form.controls['id_number'].setValue(this.employeeData.id_number);
    
    // Set base salary if available
    // if (this.employeeData.base_salary !== undefined && this.employeeData.base_salary !== null) {
    //   this.CcpsStage1Form.controls['base_salary'].setValue(this.employeeData.base_salary);
    // }
    
    this.CcpsStage1Form.controls['salary_slip_no'].setValue(this.employeeData.salary_slip_no);
    
    // Set CNSS Registration specific fields
    if (this.employeeData.birth_certificate_number) {
      this.CcpsStage1Form.controls['birth_certificate_number'].setValue(this.employeeData.birth_certificate_number);
    }
    
    if (this.employeeData.birth_certificate_issue_date) {
      const birthCertIssueDate = new Date(this.employeeData.birth_certificate_issue_date);
      birthCertIssueDate.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['birth_certificate_issue_date'].setValue(birthCertIssueDate);
    }
    
    if (this.employeeData.id_proof_expiry_date) {
      const idProofExpiryDate = new Date(this.employeeData.id_proof_expiry_date);
      idProofExpiryDate.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['id_proof_expiry_date'].setValue(idProofExpiryDate);
    }
    
    // Set professional category (for CNSS form)
    if (this.employeeData.professional_category) {
      this.CcpsStage1Form.controls['professional_category'].setValue(this.employeeData.professional_category);
      this.selectedProfessionalCategory = String(this.employeeData.professional_category);
    }
    
    // Set professional category other if professional category is 7
    if (this.employeeData.professional_category_other && (this.employeeData.professional_category == '7')) {
      this.CcpsStage1Form.controls['professional_category_other'].setValue(this.employeeData.professional_category_other);
    }
    
    // Set employee type (if not already set)
    if (this.employeeData.employee_type) {
      this.CcpsStage1Form.controls['employee_type'].setValue(this.employeeData.employee_type);
      this.selectedEmployeeType = String(this.employeeData.employee_type);
    }
    
    // Set employee type other if employee type is 7
    if (this.employeeData.employee_type_other && (this.employeeData.employee_type == '7')) {
      this.CcpsStage1Form.controls['employee_type_other'].setValue(this.employeeData.employee_type_other);
    }
    
    // Set professional rank (if not already set)
    if (this.employeeData.professional_rank) {
      this.CcpsStage1Form.controls['professional_rank'].setValue(this.employeeData.professional_rank);
    }
    
    // Set contract end date (if not already set)
    if (this.employeeData.contract_end_date) {
      const contractEndDate = new Date(this.employeeData.contract_end_date);
      contractEndDate.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['contract_end_date'].setValue(contractEndDate);
    }
    
    // Set hiring certificate date (if not already set)
    if (this.employeeData.hiring_certificate_date) {
      const hiringCertDate = new Date(this.employeeData.hiring_certificate_date);
      hiringCertDate.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['hiring_certificate_date'].setValue(hiringCertDate);
    }
    
    // Set public sector fields
    // if (this.employeeData.employee_id) {
    //   this.CcpsStage1Form.controls['employee_id'].setValue(this.employeeData.employee_id);
    // }
    
    // if (this.employeeData.index) {
    //   this.CcpsStage1Form.controls['index'].setValue(this.employeeData.index);
    // }
    
    // if (this.employeeData.grade) {
    //   this.CcpsStage1Form.controls['grade'].setValue(this.employeeData.grade);
    // }
    
    if (this.employeeData.category) {
      this.CcpsStage1Form.controls['category'].setValue(this.employeeData.category);
    }
    
    // Set private sector fields
    if (this.employeeData.employment_start_date) {
      const employmentStartDate = new Date(this.employeeData.employment_start_date);
      employmentStartDate.setHours(0, 0, 0, 0);
      this.CcpsStage1Form.controls['employment_start_date'].setValue(employmentStartDate);
    }
    
    if (this.employeeData.nature_of_activity) {
      this.CcpsStage1Form.controls['nature_of_activity'].setValue(this.employeeData.nature_of_activity);
    }
    
    if (this.employeeData.employer_organization_id || this.employeeData.employer_cnamgs) {
      this.CcpsStage1Form.controls['employer_organization_id'].setValue(this.employeeData.employer_organization_id || this.employeeData.employer_cnamgs);
    }
    
    // if (this.employeeData.employee_id_employer) {
    //   this.CcpsStage1Form.controls['employee_id_employer'].setValue(this.employeeData.employee_id_employer);
    // }
    this.minJoinDate = new Date(this.employeeData.resignation_date);
    this.minJoinDate.setHours(0, 0, 0, 0);
    console.log(this.minJoinDate)
    this.CcpsStage1Form.controls['joindate'].setValue(this.employeeData.join_date);
    // this.CcpsStage1Form.controls['administrative_status_public'].setValue(this.employeeData.administrative_status_public);
    this.CcpsStage1Form.controls['administrative_status_private'].setValue(this.employeeData.administrative_status_private);
    this.CcpsStage1Form.controls['marriage_date'].setValue(this.employeeData.marriage_date);
    // this.CcpsStage1Form.controls['administration_code'].setValue(this.employeeData.administration_code);
    this.CcpsStage1Form.controls['category_private'].setValue(this.employeeData.category_private);
    // this.CcpsStage1Form.controls['category_public'].setValue(this.employeeData.category_public);
    // Update available years based on join date
    // if (this.employeeData.join_date) {
    //   this.updateAvailableYearsFromJoinDate(this.employeeData.join_date);
    // }

    // this.CcpsStage1Form.controls['salary'].setValue(this.employeeData.salary);
    this.CcpsStage1Form.controls['position'].setValue(this.employeeData.designation);
    // Don't set CNAMGS value here for Hiring resubmit flow - it will be set conditionally based on is_cnamgs flag
    if (!(this.resubmit && !this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow && this.employeeWithCcpsStage1)) {
      this.CcpsStage1Form.controls['cnamgs'].setValue(this.employeeData.cnamgs);
    }
    this.CcpsStage1Form.controls['specialty'].setValue(this.employeeData.specialty);
    // Set ID Front Photo (CNSS form)
    // if (this.employeeData.image_Front || this.employeeData.image_front) {
    //   this.CcpsStage1Form.controls['id_Front_Photo'].setValue(this.employeeData.image_Front || this.employeeData.image_front);
    //   this.id_Front_Photo = this.employeeData.image_Front_url || this.employeeData.image_front_url;
    // }

    // Set employee_Photo form control value - if image exists, set it to clear required validation
    if (this.employeeData.profile_Image || this.employeeData.image) {
      this.CcpsStage1Form.controls['employee_Photo'].setValue(this.employeeData.profile_Image || this.employeeData.image);
      this.employee_Photo = this.employeeData.profile_Image_url || this.employeeData.image_url;
    }

    // Set spouse_birth_certificate (for old form structure)
    if (this.employeeData.spouse_birth_certificate) {
      this.CcpsStage1Form.controls['spouse_birth_certificate'].setValue(this.employeeData.spouse_birth_certificate);
      this.spouse_birthCertificate_url = this.employeeData.spouse_birth_certificate_url;
    }

    // this.CcpsStage1Form.controls['marriage_document'].setValue(this.employeeData.profile_Image);
    this.CcpsStage1Form.controls['maiden_name'].setValue(this.employeeData.maiden);

    // Set spouse_certificate (for old form structure)
    if (this.employeeData.spouse_certificate) {
      this.CcpsStage1Form.controls['spouse_certificate'].setValue(this.employeeData.spouse_certificate);
      this.spouseCertificate_url = this.employeeData.spouse_certificate_url;
    }

    // Set CNAMGS Registration form values - File names and URLs
    // Based on API payload: id_proof, employee_birth_certificate_cnamgs, marriage_certificate_cnamgs, spouse_birth_certificate_cnamgs, payslips
    if (this.employeeData.id_proof) {
      this.CcpsStage1Form.controls['id_proof'].setValue(this.employeeData.id_proof);
      this.id_proof_url = this.employeeData.id_proof_url;

      this.CcpsStage1Form.controls['id_Front_Photo'].setValue(this.employeeData.id_proof);
      this.id_Front_Photo = this.employeeData.id_proof_url;
    }
    if (this.employeeData.employee_birth_certificate_cnamgs) {
      this.CcpsStage1Form.controls['employee_birth_certificate_cnamgs'].setValue(this.employeeData.employee_birth_certificate_cnamgs);
      this.employee_birth_certificate_cnamgs_url = this.employeeData.employee_birth_certificate_cnamgs_url;

      this.CcpsStage1Form.controls['birth_certificate_file'].setValue(this.employeeData.employee_birth_certificate_cnamgs);
      this.birth_certificate_file_url = this.employeeData.employee_birth_certificate_cnamgs_url;
    }
    if (this.employeeData.marriage_certificate_cnamgs) {
      this.CcpsStage1Form.controls['marriage_certificate_cnamgs'].setValue(this.employeeData.marriage_certificate_cnamgs);
      this.marriage_certificate_cnamgs_url = this.employeeData.marriage_certificate_cnamgs_url;

      this.CcpsStage1Form.controls['marriage_certificate_file'].setValue(this.employeeData.marriage_certificate_cnamgs);
      this.marriage_certificate_file_url = this.employeeData.marriage_certificate_cnamgs_url;
    }
    if (this.employeeData.spouse_birth_certificate_cnamgs) {
      this.CcpsStage1Form.controls['spouse_birth_certificate_cnamgs'].setValue(this.employeeData.spouse_birth_certificate_cnamgs);
      this.spouse_birth_certificate_cnamgs_url = this.employeeData.spouse_birth_certificate_cnamgs_url;
    }
    if (this.employeeData.payslips) {
      this.CcpsStage1Form.controls['payslips'].setValue(this.employeeData.payslips);
      this.payslips_url = this.employeeData.payslips_url;
    }

    // Set CNSS Registration form values - File names and URLs
    // Based on API payload: birth_certificate_file, marriage_certificate_file
    // if (this.employeeData.birth_certificate_file) {
    //   this.CcpsStage1Form.controls['birth_certificate_file'].setValue(this.employeeData.birth_certificate_file);
    //   this.birth_certificate_file_url = this.employeeData.birth_certificate_file_url;
    // }
    // if (this.employeeData.marriage_certificate_file) {
    //   this.CcpsStage1Form.controls['marriage_certificate_file'].setValue(this.employeeData.marriage_certificate_file);
    //   this.marriage_certificate_file_url = this.employeeData.marriage_certificate_file_url;
    // }

    // Load salary data if available (new year-based structure)
    if (this.employeeData.salary && Array.isArray(this.employeeData.salary) && this.employeeData.salary.length > 0) {
      this.salaryListByYear = {};

      // New format: salary is an array with first element containing all years
      const salaryData = this.employeeData.salary[0];

      if (typeof salaryData === 'object') {
        // Iterate through each year key in the object
        Object.keys(salaryData).forEach(yearKey => {
          // Check if the key is a year (numeric string like "2023", "2024", etc.)
          if (!isNaN(parseInt(yearKey)) && Array.isArray(salaryData[yearKey])) {
            // Copy the salary data for this year
            this.salaryListByYear[yearKey] = salaryData[yearKey].map(item => ({
              month: item.month,
              value: item.value,
              salary_id: item.salary_id
            }));
          }
        });
      }

      console.log("Loaded salary list by year:", this.salaryListByYear);

      // Re-initialize year expansion to include all years from loaded data
      Object.keys(this.salaryListByYear).forEach(year => {
        if (this.expandedYears[year] === undefined) {
          this.expandedYears[year] = false;
        }
      });

      // Expand the most recent year by default
      const years = Object.keys(this.salaryListByYear).sort();
      if (years.length > 0) {
        this.expandedYears[years[years.length - 1]] = true;
      }
    }

    console.log("569")
    
    // Populate common fields for Form 2 and Form 3
    this.setCommonFormFields();
    
    // Populate Form 1 (CNAMGS Yes form) fields if applicable
    this.setCnamgsYesFormValues();
    
    // const photoProperties = [
    //   { elementId: 'employeePhoto', apiValue: this.employeeData.image },
    //   { elementId: 'idFrontPhoto', apiValue: this.employeeData.image_front },
    // ];
    // for (const property of photoProperties) {
    //   const element = document.getElementById(property.elementId);
    //   if (property.apiValue) {
    //     element.textContent = this.currentLang === 'fr' ?
    //       `Cliquez pour voir le fichier` :
    //       `Click to view File`;
    //   }
    // }
  }

  onEducationLevelChange(event: any) {
    const selectedValue = String((event.target as HTMLSelectElement).value);
    if (selectedValue != '13') {
      // Clear other_qualification when not '13'
      this.CcpsStage1Form.controls['other_qualification'].setValue('');
      this.CcpsStage1Form.controls['other_qualification'].clearValidators();
      this.CcpsStage1Form.controls['other_qualification'].updateValueAndValidity();
    } else {
      // Clear validators for other_qualification
      this.CcpsStage1Form.controls['other_qualification'].clearValidators();
      this.CcpsStage1Form.controls['other_qualification'].updateValueAndValidity();
    }
  }

  makeInputReadOnly() {
    // Object.keys(this.CcpsStage1Form.controls).forEach(controlName => {
    //   this.CcpsStage1Form.get(controlName).disable();
    //   console.log("422")
    // });
    console.log("disabledddddddddddddddddddd")
    this.g.cnamgs.disable();
    this.g.cnss.disable();
    this.g.dob.disable();
  }
  makeInputEditable() {
    Object.keys(this.CcpsStage1Form.controls).forEach(controlName => {
      this.CcpsStage1Form.get(controlName).enable();
      console.log("input are editable")
    });
  }
  showAddEmployee(id: any, val) {
    this.id = id;
    console.log("172", this.id)
    console.log("173", val)
    console.log("174", this.employeeNifNumber)
    if (val == '2') {
      this.employeeBeforeSubmit = true;
      $('#allEmployeeModal').modal('hide');
    }
    if (this.id) {

      // Reset all registration flow flags to ensure clean state when switching between entity types
      this.isCnssEmployeeRegistrationFlow = false;
      this.isCnamgsEmployeeRegistrationFlow = false;
      this.showCnssSection = false;
      this.hideCnssSection = false;
      this.hideCnamgsSection = false;
      this.isCNSSSectionValue = false;
      this.isCnamgsSectionValue = false;
      
      // Ensure form controls are enabled and reset values when switching flows
      setTimeout(() => {
        const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
        const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
        
        if (isRegisteredCnssControl) {
          isRegisteredCnssControl.enable();
          // Don't set value here - will be set based on entity_type below
        }
        
        if (isRegisteredCnamgsControl) {
          isRegisteredCnamgsControl.enable();
          // Don't set value here - will be set based on entity_type below
        }
        
        // Ensure CNSS and CNAMGS input fields are enabled (they might have been disabled by makeInputReadOnly)
        const cnssControl = this.CcpsStage1Form.get('cnss');
        if (cnssControl) {
          cnssControl.enable();
        }
        
        const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
        if (cnamgsControl) {
          cnamgsControl.enable();
        }
      }, 50);

      this.idTypeList();
      this.getCountryData();
      this.getRegionData();
      this.getEducationList();
      this.getRejectedEmployeeDetails()
      this.contractTypeList();
      this.getProfessionalRankList();
      this.getEmployeeTypeList();
      this.getMaritalStatusList();
      this.getProfessionalCategoryList();
      this.getAffiliationTypeList();
      this.getEmployeeCategoryList();
      this.getAdministrativeStatusList();
      if (val == '2') {
         this.resubmit = true
      this.employeeWithCcpsStage1 = true;
        // CNSS Employee Registration Flow: Show only CNSS section with "no" selected
        this.isCNSSSectionValue = false; // Show input/question section
        this.hideCnamgsSection = true; // Hide CNAMGS section completely
        this.hideCnssSection = false; // Ensure CNSS section is visible
        this.isCnamgsSectionValue = true; // Hide CNAMGS input/question section


        setTimeout(() => {
          const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
          if (isRegisteredCnssControl) {
            isRegisteredCnssControl.enable();
            isRegisteredCnssControl.setValue('no', { emitEvent: false }); // Set to "no"
          }

          // Clear CNSS value
          const cnssControl = this.CcpsStage1Form.get('cnss');
          if (cnssControl) {
            cnssControl.enable();
            cnssControl.setValue('');
          }

          // Reset CNAMGS to default
          const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
          if (isRegisteredCnamgsControl) {
            isRegisteredCnamgsControl.enable();
            isRegisteredCnamgsControl.setValue('yes', { emitEvent: false });
          }
        }, 100);

        // Set flags to show CNSS registration form
        this.isCnssEmployeeRegistrationFlow = true;
        this.showCnssSection = true;
      } else 
      if (val == '3') {
        this.resubmit = true
        this.employeeWithCcpsStage1 = true;
        // CNAMGS Employee Registration Flow: Show only CNAMGS section with "no" selected
        this.isCnamgsSectionValue = false; // Show input/question section
        this.hideCnssSection = true; // Hide CNSS section completely
        this.hideCnamgsSection = false; // Ensure CNAMGS section is visible
        this.isCNSSSectionValue = true; // Hide CNSS input/question section


        setTimeout(() => {
          const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
          if (isRegisteredCnamgsControl) {
            isRegisteredCnamgsControl.enable();
            isRegisteredCnamgsControl.setValue('no', { emitEvent: false }); // Set to "no"
          }

          // Clear CNAMGS value
          const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
          if (cnamgsControl) {
            cnamgsControl.enable();
            cnamgsControl.setValue('');
          }

          // Reset CNSS to default
          const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
          if (isRegisteredCnssControl) {
            isRegisteredCnssControl.enable();
            isRegisteredCnssControl.setValue('yes', { emitEvent: false });
          }
        }, 100);

        // Set flag to show CNAMGS registration form
        this.isCnamgsEmployeeRegistrationFlow = true;
      } else if (val == '1') {
        // Hiring Resubmit Flow: Set initial flags, conditional logic will be applied after API response
        this.resubmit = true;
        this.employeeWithCcpsStage1 = true;
        // Ensure both sections are visible (reset hide flags)
        this.hideCnssSection = false;
        this.hideCnamgsSection = false;
        // Don't set isCNSSSectionValue and isCnamgsSectionValue here - 
        // getRejectedEmployeeDetails() will set them based on API response (is_cnss and is_cnamgs)

        // Set form controls to 'yes' by default and ensure they are enabled (will be populated after API response)
        setTimeout(() => {
          const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
          if (isRegisteredCnssControl) {
            isRegisteredCnssControl.enable();
            isRegisteredCnssControl.setValue('yes', { emitEvent: false });
          }

          const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
          if (isRegisteredCnamgsControl) {
            isRegisteredCnamgsControl.enable();
            isRegisteredCnamgsControl.setValue('yes', { emitEvent: false });
          }
          
          // Ensure CNSS and CNAMGS input fields are enabled (they might have been disabled by makeInputReadOnly)
          const cnssControl = this.CcpsStage1Form.get('cnss');
          if (cnssControl) {
            cnssControl.enable();
          }
          
          const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
          if (cnamgsControl) {
            cnamgsControl.enable();
          }
          
          // CNSS and CNAMGS values will be populated in getRejectedEmployeeDetails() 
          // based on isCNSSSectionValue and isCnamgsSectionValue flags
        }, 150);
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  getRejectedEmployeeDetails() {
    this.ngxUiLoaderService.start();
    this.api.getRejectedEmployeeData(this.id).pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();

        console.log("654", data)
        if (data.status == 200) {
          this.employeeData = data.results;
          this.rejectReason = data.verification;
          // this.reasonText = this.employeeData.reason;
          // this.rejectedBy = this.employeeData.process_by;
          // this.rejectedDate = this.employeeData.process_date;
          this.employeeNifNumber = this.employeeData.nif;
          this.employeeNipNumber = this.employeeData.nip_number;
          
          // Debug: Log CNSS/CNAMGS values from API
          console.log("=== CNSS/CNAMGS API Values Debug ===");
          console.log("employeeData.cnss:", this.employeeData.cnss);
          console.log("employeeData.cnamgs:", this.employeeData.cnamgs);
          console.log("employeeData.is_cnss:", this.employeeData.is_cnss);
          console.log("employeeData.is_cnamgs:", this.employeeData.is_cnamgs);
          console.log("====================================");
          
          // Apply conditional CNSS/CNAMGS logic for Hiring resubmit flow BEFORE setEmployeeDetailsValues
          // Check if this is a resubmit flow and not CNSS/CNAMGS registration flows
          if (this.resubmit && !this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow && this.employeeWithCcpsStage1) {
            // Ensure both sections are visible (reset hide flags)
            this.hideCnssSection = false;
            this.hideCnamgsSection = false;

            // CNSS Section Logic: Check is_cnss flag to determine display vs form section
            this.isCNSSSectionValue = (this.employeeData && this.employeeData.is_cnss === true);

            // CNAMGS Section Logic: Check is_cnamgs flag to determine display vs form section
            this.isCnamgsSectionValue = (this.employeeData && this.employeeData.is_cnamgs === true);
            
            console.log("=== Section Visibility Flags ===");
            console.log("isCNSSSectionValue:", this.isCNSSSectionValue);
            console.log("isCnamgsSectionValue:", this.isCnamgsSectionValue);
            console.log("================================");
          }
          
          this.setEmployeeDetailsValues();
          this.formInitialized = true; // Mark form as initialized

          // Populate CNSS/CNAMGS form controls based on section type AFTER setEmployeeDetailsValues
          if (this.resubmit && !this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow && this.employeeWithCcpsStage1) {
            // Use setTimeout to ensure form controls are ready after setEmployeeDetailsValues completes
            setTimeout(() => {
              // CNSS Form Controls
              const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
              const cnssControl = this.CcpsStage1Form.get('cnss');
              
              if (isRegisteredCnssControl) {
                // Always set to 'yes' (default for both display and form sections)
                isRegisteredCnssControl.setValue('yes', { emitEvent: false });
              }

              if (cnssControl) {
                if (this.isCNSSSectionValue) {
                  // Display section: Populate value from employeeData (read-only display)
                  const cnssValue = (this.employeeData && this.employeeData.cnss) ? this.employeeData.cnss : '';
                  console.log("Setting CNSS value (display section):", cnssValue);
                  cnssControl.setValue(cnssValue, { emitEvent: false });
                } else {
                  // Form section: Populate with existing value from API for editing (resubmit flow)
                  const cnssValue = (this.employeeData && this.employeeData.cnss) ? this.employeeData.cnss : '';
                  console.log("Setting CNSS value (form section - editable):", cnssValue);
                  cnssControl.setValue(cnssValue, { emitEvent: false });
                }
                console.log("CNSS control value after set:", cnssControl.value);
              }

              // CNAMGS Form Controls
              const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
              const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
              
              if (isRegisteredCnamgsControl) {
                // Always set to 'yes' (default for both display and form sections)
                isRegisteredCnamgsControl.setValue('yes', { emitEvent: false });
              }

              if (cnamgsControl) {
                if (this.isCnamgsSectionValue) {
                  // Display section: Populate value from employeeData (read-only display)
                  const cnamgsValue = (this.employeeData && this.employeeData.cnamgs) ? this.employeeData.cnamgs : '';
                  console.log("Setting CNAMGS value (display section):", cnamgsValue);
                  cnamgsControl.setValue(cnamgsValue, { emitEvent: false });
                } else {
                  // Form section: Populate with existing value from API for editing (resubmit flow)
                  const cnamgsValue = (this.employeeData && this.employeeData.cnamgs) ? this.employeeData.cnamgs : '';
                  console.log("Setting CNAMGS value (form section - editable):", cnamgsValue);
                  cnamgsControl.setValue(cnamgsValue, { emitEvent: false });
                }
                console.log("CNAMGS control value after set:", cnamgsControl.value);
              }
            }, 300);
          }
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  downloadExcel() {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString().replace(/[\/\:\,\s]/g, '_');
    const fileName = `'Bulk Upload Employees'_${formattedDate}.xlsx`;

    const headers = [
      'N° NIP',
      'N° CNSS',
      'N° CNAMGS (NAG)',
      'Prénom(s) et Nom(s)',
      'Numéro de paie',
      'Date d\'embauche',
      'Date de départ',
      'Allocations familiales',
      'Mois 1 – Salaire Déplafonné\nCNSS',
      'Mois 1 – Salaire Déplafonné\nCNAMGS',
      'Mois 2 – Salaire Déplafonné\nCNSS',
      'Mois 2 – Salaire Déplafonné\nCNAMGS',
      'Mois 3 – Salaire Déplafonné\nCNSS',
      'Mois 3 – Salaire Déplafonné\nCNAMGS'
    ];

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([headers]);

    ws['!cols'] = [
      { wch: 14 },
      { wch: 12 },
      { wch: 18 },
      { wch: 26 },
      { wch: 16 },
      { wch: 16 },
      { wch: 14 },
      { wch: 20 },
      { wch: 28 },
      { wch: 31 },
      { wch: 28 },
      { wch: 31 },
      { wch: 28 },
      { wch: 31 }
    ];
    ws['!rows'] = [{ hpt: 32 }];

    // Attempt to enable wrapping on header cells (may be ignored depending on build of xlsx)
    for (let c = 0; c < headers.length; c++) {
      const addr = XLSX.utils.encode_cell({ r: 0, c });
      const cell = ws[addr];
      if (cell) {
        (cell as any).s = {
          alignment: { wrapText: true, vertical: 'center' }
        };
      }
    }

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Employees');

    // Generate Excel file and download
    XLSX.writeFile(wb, fileName);
    console.log("file name :", fileName);
  }

  get f() {
    return this.withCcpsForm.controls;
  }
  get g() {
    return this.CcpsStage1Form.controls;
  }
  get a() {
    return this.resignationForm.controls;
  }

  goback() {
    this.resetFields();
    this.isSubmitted = false;
    this.isSubmit = false;
    this.isSubmit2 = false;
    this.g.cnamgs.enable();
    this.g.cnss.enable();
    this.location.back();
  }

  addmore() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.withCcpsForm.reset();
    this.CcpsStage1Form.reset();
    this.selectedValue = null;
    this.selectedNationalityValue = null;
    this.selectedEducationLevel = null;
    this.selectedBirthcountryValue = null;
    this.resignReason = null;
    this.selectedregionValue = null;
    this.selectedCityValue = null;
    this.selectedDistrictValue = null;
    this.selectedDistrictValue = null;
    this.selectedcontractValue = null;
    this.selectedmaritalValue = null;
    console.log("651")
    this.isSubmitted = false;
    this.isSubmit = false;
    this.isSubmit2 = false;
    this.id_Front_Photo = null;
    this.employee_Photo = null;
    this.spouse_birthCertificate_url = null;
    this.spouseCertificate_url = null;


    this.resetFields()
    $('#allEmployeeModal').modal('hide');
    setTimeout(() => {
      $('#addEmployeeModal').modal('show');
    }, 500)
  }
  resetFields() {
    this.CcpsStage1Form.reset();
    // Set yearMonth back to previous month after reset
    // this.CcpsStage1Form.get('select_period').setValue(this.getPreviousMonth());
    // Set nationality back to default
    this.CcpsStage1Form.get('nationality').setValue('77');
    // Set year back to current year
    this.CcpsStage1Form.get('year').setValue(this.currentYear);
    // Set CNSS registration back to default 'yes'
    // Reset CNAMGS question flag
    this.showCNAMGSQuestion = false;
    // Reset form initialization flag
    this.formInitialized = false;
    this.CcpsStage1Form.get('is_registered_cnss').setValue('yes');
    // Set CNAMGS registration back to default 'yes'
    this.CcpsStage1Form.get('is_registered_cnamgs').setValue('yes');
    // Reset flag for CNSS registration flow
    this.isFromNoCnssRegistration = false;
    // Reset flag for CNAMGS registration flow
    this.isFromNoCnamgsRegistration = false;
    // Reset flag for CNAMGS "Yes" registration flow
    this.isFromCnamgsYesRegistration = false;

    // Reset available months and auto-select first month
    this.initMonthsUpToPrevious();

    // Reset ccpsId to null when starting new employee addition
    this.ccpsId = null;
    // Clear salary preview data
    this.salaryListByYear = {};
    this.expandedYears = {};
    this.availableYears = [this.currentYear];
    this.isEditing = false;
    this.editingIndex = null;
    this.editingYear = null;

    this.id_Front_Photo = null;
    this.employee_Photo = null;
    this.spouseCertificate_url = null;
    this.spouse_birthCertificate_url = null;
    this.id_proof_url = null;
    this.birth_certificate_file_url = null;
    this.marriage_certificate_file_url = null;
    this.employee_birth_certificate_cnamgs_url = null;
    this.marriage_certificate_cnamgs_url = null;
    this.spouse_birth_certificate_cnamgs_url = null;
    this.payslips_url = null;
    // Reset form initialization flag
    this.formInitialized = false;
    console.log("forms reset")
  }

  convertOwl(str) {
    if (str == null)
      return str;
    var mnths = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12"
    },

      date = str.toString().split(" ");
    if (date.length == 1)
      return str;
    else
      return [date[2], mnths[date[1]], date[3]].join("-");
  }

  // idTypeList1() {
  //   this.api.getidTypeList().pipe(first())
  //     .subscribe(data => {
  //         this.idtype = data;
  //         if (this.idtype.status == 200) {
  //           this.idtypelist = this.idtype.results;
  //           console.log("696")
  //           this.CcpsStage1Form.reset();
  //           this.CcpsStage1Form.get('id_type').setValue(null);
  //         }
  //       },
  //       error => {});
  // }

  idTypeList() {
    var data = {
      identityType: '1',
    };
    this.api.getidTypeList(data).pipe(first())
      .subscribe(data => {
        this.idtype = data;
        if (this.idtype.status == 200) {
          this.idtypelist = this.idtype.results;
          console.log(this.CcpsStage1Form.get('nationality').value)
          console.log(this.idtypelist)
        } else {
          this.snackBar.open(this.response.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
        });
  }


  contractTypeList() {
    this.api.getcontractTypeList().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        this.idtype = data;
        if (this.idtype.status == 200) {
          this.contract = this.idtype.results;
          console.log(this.contract, "99999999999")
          //this.CcpsStage1Form.reset();
          // this.CcpsStage1Form.get('type_of_contract').setValue(null);
        } else {
          this.snackBar.open(this.contract.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }


  getCountryData() {
    this.api.getCountryList().pipe(first())
      .subscribe(res => {
        this.response = res;
        if (this.response.status == 200) {
          this.countryList = this.response.results;
          this.idTypeList();
          console.log("sdasadsadasdasdsadasdasdsadasdsa")
          setTimeout(() => {

            this.CcpsStage1Form.controls['nationality'].setValue('77');
            this.CcpsStage1Form.controls['nationality'].updateValueAndValidity();

            console.log(this.CcpsStage1Form.controls['nationality'].value)
            // this.CcpsStage1Form.controls['id_type'].disable(); 

            this.CcpsStage1Form.controls['birthcountry'].setValue('77');
            this.CcpsStage1Form.controls['birthcountry'].updateValueAndValidity();

          }, 500)

          console.log("Shakundhaleeeeeeeeeeeeeeeeeee", this.countryList)
        } else {
          console.log('null kerrrrriririririri');

          this.CcpsStage1Form.controls['id_type'].enable();
          this.CcpsStage1Form.controls['id_type'].setValue(null);

          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {

        });
  }
  getRegionData() {
    this.api.getRegionList().pipe(first())
      .subscribe(res => {
        this.response = res;
        console.log("ing vaaada mowone.............!", this.response)
        if (this.response.status == 200) {
          this.regionList = this.response.results;
          console.log("522", this.regionList)
        } else {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }

  getEducationLevelData() {
    this.api.getEducationLevelList().pipe(first())
      .subscribe(res => {
        this.response = res;
        console.log("ing vaaada mowone.............!", this.response)
        if (this.response.status == 200) {
          this.educationLevelList = this.response.results;
          console.log("522", this.educationLevelList)
        } else {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }

  changeRegion(id) {
    this.cityList = null;
    this.districtList = null;
    this.g.city.setValue(null);
    this.g.city.updateValueAndValidity();

    this.g.district.setValue(null);
    this.g.district.clearValidators();
    this.g.district.updateValueAndValidity();

    this.g.neighborhood.setValue(null);
    this.g.neighborhood.clearValidators();
    this.g.neighborhood.updateValueAndValidity();

    // this.ngxUiLoaderService.start();
    this.api.getCityList(id).pipe(first()).subscribe(res => {
      this.response = res;
      if (this.response.status == 200) {
        // this.ngxUiLoaderService.stop();
        this.cityList = this.response.results;
        console.log("kitty poyedaaaa....!!!!", this.cityList)
      } else {
        this.snackBar.open(this.cityList.message, "OK", {
          duration: 5000,
        });
      }
    })
  }
  changeCity(city) {
    this.districtList = null;
    this.g.district.setValue(null);
    this.g.district.updateValueAndValidity();
    this.g.neighborhood.setValue(null);
    this.g.neighborhood.clearValidators();
    this.g.neighborhood.updateValueAndValidity();

    // this.ngxUiLoaderService.start();
    this.api.getDistrictList(city).pipe(first())
      .subscribe(res => {
        this.response = res;
        if (this.response.status == 200) {
          // this.ngxUiLoaderService.stop();
          if (this.response.results.length === 0) {
            this.g.district.clearValidators();
            this.g.district.updateValueAndValidity();
          } else {
            this.g.district.clearValidators();
            this.g.district.updateValueAndValidity();
            this.districtList = this.response.results;
            console.log("entha monusse jaadayano....!", this.districtList)
          }
        } else {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {

        });
  }
  changeDistrict(district) {
    this.neighborhoodList = null;
    this.g.neighborhood.setValue(null);
    this.g.neighborhood.updateValueAndValidity();

    var data = {};
    data['city_id'] = this.g.city.value;
    data['district_id'] = district;

    // this.ngxUiLoaderService.start();
    this.api.getNeighbourhoodList1(data).pipe(first())
      .subscribe(res => {
        this.response = res;
        if (this.response.status == 200) {
          if (this.response.results.length === 0) {
            this.g.neighborhood.clearValidators();
            this.g.neighborhood.updateValueAndValidity();
          } else {
            this.g.neighborhood.clearValidators();
            this.g.neighborhood.updateValueAndValidity();
            this.neighborhoodList = this.response.results;
            console.log("kollaalo neeey...!", this.neighborhoodList)
          }
          // this.ngxUiLoaderService.stop();
        } else {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {

        });
  }

  onCNSSRegistrationChange() {
    // Get the current value from the form control
    const value = this.g.is_registered_cnss.value;

    // Check if we're in hiring flow (not CNSS/CNAMGS registration flows)
    const isHiringFlow = !this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow && this.employeeWithCcpsStage1;

    // In hiring flow, update hideFormSectionsOnNo based on both CNSS and CNAMGS values
    if (isHiringFlow) {
      const cnssValue = this.g.is_registered_cnss.value;
      const cnamgsValue = this.g.is_registered_cnamgs.value;
      // Hide form sections if either CNSS or CNAMGS is "no"
      this.hideFormSectionsOnNo = (cnssValue === 'no' || cnamgsValue === 'no');
    }

    // When CNSS "No" is selected, hide CNAMGS Verification section
    if (value === 'no') {
      this.showCNAMGSQuestion = false;
      this.showCnamgsYesForm = false;
    } else if (value === 'yes') {
      // When CNSS "Yes" is selected, enable CNAMGS section
      this.showCNAMGSQuestion = true;
    }
  }

  onCNAMGSRegistrationChange() {
    // Get the current value from the form control
    const value = this.g.is_registered_cnamgs.value;

    // Check if we're in hiring flow (not CNSS/CNAMGS registration flows)
    const isHiringFlow = !this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow && this.employeeWithCcpsStage1;

    // In hiring flow, update hideFormSectionsOnNo based on both CNSS and CNAMGS values
    if (isHiringFlow) {
      const cnssValue = this.g.is_registered_cnss.value;
      const cnamgsValue = this.g.is_registered_cnamgs.value;
      // Hide form sections if either CNSS or CNAMGS is "no"
      this.hideFormSectionsOnNo = (cnssValue === 'no' || cnamgsValue === 'no');
    }
  }

  proceedToCNAMGS() {
    // Close the modal
    $('#allEmployeeModal').modal('hide');
    // Show the CNAMGS question section
    this.showCNAMGSQuestion = true;
    // Ensure form is visible
    this.employeeWithCcpsStage1 = true;
    this.employeeList = false;
    // Query parameters removed - no longer needed
    // Set CNSS registration to 'yes' if not already set
    setTimeout(() => {
      const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
      if (isRegisteredCnssControl && (!isRegisteredCnssControl.value || isRegisteredCnssControl.value === '')) {
        isRegisteredCnssControl.setValue('yes');
      }
    }, 100);
  }

  closeCnamgsModal() {
    // Close the modal
    $('#allEmployeeModal').modal('hide');
    // Reset flags
    this.isFromNoCnamgsRegistration = false;
    this.showCNAMGSQuestion = false;
    this.employeeWithCcpsStage1 = false;
    this.employeeList = false; // Show employee list section
    // Reset form
    this.resetFields();
    // Clear URL parameters
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {}
    });
    // Show success modal first, then refresh employee list without opening the "List of Employees to Add" modal
    setTimeout(() => {
      $('#addEmployeeSuccessModal').modal('show');
      // Refresh employee list after showing success modal (use 3 to prevent auto-opening the modal)
      setTimeout(() => {
        this.anpiService.emitEvent();
        // this.getEmployeeList(3);
      }, 500);
    }, 500);
  }

  showModalCNAMGS() {
    // Check if we're in hiring flow (not CNSS/CNAMGS registration flows)
    const isHiringFlow = !this.isCnssEmployeeRegistrationFlow && !this.isCnamgsEmployeeRegistrationFlow && this.employeeWithCcpsStage1;

    // Handle CNSS validation in hiring flow
    if (isHiringFlow) {
      // Check if CNSS form section is visible (user needs to enter CNSS value)
      const isCnssFormVisible = !this.isCNSSSectionValue && !this.hideCnssSection;
      
      if (isCnssFormVisible) {
        const cnssValue = this.g.is_registered_cnss.value;
        
        // If CNSS "No" is selected, show modal and exit
        if (cnssValue === 'no') {
          this.employeeWithCcpsStage1 = false;
          this.isSuccessModal = false;
          this.modalHeading = 'OOPS !';
          this.modalDescription = 'Employee registration cannot proceed without CNSS number. Please register with CNSS first.';
          this.hideFormSectionsOnNo = false;
          setTimeout(() => {
            $('#companyNotFoundModal').modal('show');
          }, 100);
          return;
        }
        
        // If CNSS "Yes" is selected, apply validation only to CNSS field (don't clear other fields)
        if (cnssValue === 'yes') {
          const cnssControl = this.CcpsStage1Form.get('cnss');
          if (cnssControl) {
            cnssControl.setValidators([Validators.required, Validators.pattern("^[0-9-]+$")]);
            cnssControl.updateValueAndValidity();
          }
        }
      }

      // Check if CNAMGS form section is visible (user needs to enter CNAMGS value)
      const isCnamgsFormVisible = !this.isCnamgsSectionValue && !this.hideCnamgsSection;
      
      if (isCnamgsFormVisible) {
        const cnamgsValue = this.g.is_registered_cnamgs.value;
        
        // If CNAMGS "No" is selected, show modal and exit
        if (cnamgsValue === 'no') {
          this.employeeWithCcpsStage1 = false;
          this.isSuccessModal = false;
          this.modalHeading = 'OOPS !';
          this.modalDescription = 'Employee registration cannot proceed without CNAMGS number. Please register with CNAMGS first.';
          this.hideFormSectionsOnNo = false;
          setTimeout(() => {
            $('#companyNotFoundModal').modal('show');
          }, 100);
          return;
        }
        
        // If CNAMGS "Yes" is selected, apply validation only to CNAMGS field (don't clear other fields)
        if (cnamgsValue === 'yes') {
          const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
          if (cnamgsControl) {
            cnamgsControl.setValidators([Validators.required, Validators.pattern("^[0-9-]+$")]);
            cnamgsControl.updateValueAndValidity();
          }
        }
      }
    }

    // Apply all validations
    this.applyCnamgsYesFormValidation();
    this.isSubmit = true;
    this.CcpsStage1Form.markAllAsTouched();
    
    // Check all validations at once (CNSS, CNAMGS, and hiring form fields)
    let hasValidationErrors = false;
    
    // Check CNSS validation in hiring flow
    if (isHiringFlow) {
      const isCnssFormVisible = !this.isCNSSSectionValue && !this.hideCnssSection;
      if (isCnssFormVisible && this.g.is_registered_cnss.value === 'yes') {
        if (this.g.cnss.invalid) {
          hasValidationErrors = true;
        }
      }
      
      const isCnamgsFormVisible = !this.isCnamgsSectionValue && !this.hideCnamgsSection;
      if (isCnamgsFormVisible && this.g.is_registered_cnamgs.value === 'yes') {
        if (this.g.cnamgs.invalid) {
          hasValidationErrors = true;
        }
      }
    }
    
    // Check hiring form validations
    const joindateControl = this.CcpsStage1Form.get('joindate');
    const typeOfContractControl = this.CcpsStage1Form.get('type_of_contract');
    const professionalRankControl = this.CcpsStage1Form.get('professional_rank');
    const employeeTypeControl = this.CcpsStage1Form.get('employee_type');
    const contractEndDateControl = this.CcpsStage1Form.get('contract_end_date');
    const employeeTypeOtherControl = this.CcpsStage1Form.get('employee_type_other');

    const isJoindateValid = joindateControl && joindateControl.valid;
    const isTypeOfContractValid = typeOfContractControl && typeOfContractControl.valid;
    const isProfessionalRankValid = professionalRankControl && professionalRankControl.valid;
    const isEmployeeTypeValid = employeeTypeControl && employeeTypeControl.valid;

    const isContractEndDateValid = typeOfContractControl && typeOfContractControl.value == '2'
      ? (contractEndDateControl && contractEndDateControl.valid)
      : true;
    const isEmployeeTypeOtherValid = employeeTypeControl && employeeTypeControl.value == '7'
      ? (employeeTypeOtherControl && employeeTypeOtherControl.valid)
      : true;

    if (!isJoindateValid || !isTypeOfContractValid || !isProfessionalRankValid ||
      !isEmployeeTypeValid || !isContractEndDateValid || !isEmployeeTypeOtherValid) {
      hasValidationErrors = true;
    }

    // No-ID flow: validate first_name, last_name; for hiring also require cnss and cnamgs
    if (this.employeeHasNoId) {
      const firstNameControl = this.CcpsStage1Form.get('first_name');
      const lastNameControl = this.CcpsStage1Form.get('last_name');
      if ((firstNameControl && firstNameControl.invalid) || (lastNameControl && lastNameControl.invalid)) {
        hasValidationErrors = true;
      }
      if (isHiringFlow) {
        if (this.g.is_registered_cnss.value !== 'yes' || !this.g.cnss.value || this.g.cnss.invalid) {
          hasValidationErrors = true;
        }
        if (this.g.is_registered_cnamgs.value !== 'yes' || !this.g.cnamgs.value || this.g.cnamgs.invalid) {
          hasValidationErrors = true;
        }
      }
    }

    // If any validation errors, scroll to first invalid control and return
    if (hasValidationErrors) {
      setTimeout(() => {
        this.scrollToFirstInvalidControl();
      }, 100);
      return;
    }
    this.isSubmit = false;
    const formValues = this.CcpsStage1Form.getRawValue();
    const formatDateForAPI = (date: Date | string | null): string => {
      if (!date) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };
    const apiData: any = {
      joindate: formatDateForAPI(formValues.joindate),
      hiring_certificate_date: formatDateForAPI(formValues.hiring_certificate_date),
      type_of_contract: formValues.type_of_contract,
      contract_end_date: formatDateForAPI(formValues.contract_end_date),
      professional_rank: formValues.professional_rank,
      employee_type: formValues.employee_type,
      employee_type_other: formValues.employee_type_other,
      position: formValues.position,
      entity_type: '1',
      nip_number: this.employeeHasNoId ? null : this.employeeNipNumber
    };

    if (this.employeeHasNoId) {
      apiData.is_nip_number = false;
      apiData.first_name = formValues.first_name || '';
      apiData.last_name = formValues.last_name || '';
    }

    // Add CNSS value if CNSS form is visible and "yes" is selected in hiring flow
    if (isHiringFlow) {
      const isCnssFormVisible = !this.isCNSSSectionValue && !this.hideCnssSection;
      if (isCnssFormVisible && this.g.is_registered_cnss.value === 'yes' && formValues.cnss) {
        apiData.cnss = formValues.cnss;
      }

      // Add CNAMGS value if CNAMGS form is visible and "yes" is selected in hiring flow
      const isCnamgsFormVisible = !this.isCnamgsSectionValue && !this.hideCnamgsSection;
      if (isCnamgsFormVisible && this.g.is_registered_cnamgs.value === 'yes' && formValues.cnamgs) {
        apiData.cnamgs = formValues.cnamgs;
      }
    }
    console.log("apiData", apiData)

    this.ngxUiLoaderService.start();
    this.api.getHiringData(apiData).pipe(first())
      .subscribe(
        (data: any) => {
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.employeespendingList = this.response.results;
            console.log("employeespendingList", this.response.results)
            this.idArray = this.response.results.map(employee => employee.uuid);
            // this.pendingEmployeeCount = this.response.results.length.toString();
            this.snackBar.open(this.response.message, "ok", {
              duration: 2000,
            });
            this.isFromCnamgsYesRegistration = true;
            $('#allEmployeeModal').modal('show');
          } else {
            this.ngxUiLoaderService.stop();
            this.snackBar.open(this.response.message, "ok", {
              duration: 2000,
            });
          }

        },
        (error: any) => {
          this.ngxUiLoaderService.stop();
          this.snackBar.open(this.response.message, "ok", {
            duration: 2000,
          });
        }
      );
  }

  closeCnssNoModal() {
    // Close the modal
    $('#allEmployeeModal').modal('hide');
    // Reset flags
    this.isFromNoCnssRegistration = false;
    this.showCNAMGSQuestion = false;
    this.employeeWithCcpsStage1 = false;
    this.employeeList = false; // Show employee list section
    // Reset form
    this.resetFields();
    // Clear URL parameters
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {}
    });
    // Show success modal first, then refresh employee list without opening the "List of Employees to Add" modal
    setTimeout(() => {
      $('#addEmployeeSuccessModal').modal('show');
      // Refresh employee list after showing success modal (use 3 to prevent auto-opening the modal)
      setTimeout(() => {
        this.anpiService.emitEvent();
        // this.getEmployeeList(3);
      }, 500);
    }, 500);
  }

  gobacklist() {
    this.resubmit = false;
    this.CcpsStage1Form.reset();
    // Set yearMonth back to previous month after reset
    // this.CcpsStage1Form.get('select_period').setValue(this.getPreviousMonth());
    // Set nationality back to default
    this.CcpsStage1Form.get('nationality').setValue('77');
    // Set year back to current year
    this.CcpsStage1Form.get('year').setValue(this.currentYear);
    // Set CNSS registration back to default 'yes'
    this.CcpsStage1Form.get('is_registered_cnss').setValue('yes');
    // Set CNAMGS registration back to default 'yes'
    this.CcpsStage1Form.get('is_registered_cnamgs').setValue('yes');
    // Reset CNAMGS question flag
    this.showCNAMGSQuestion = false;
    // Reset flags
    this.isFromNoCnssRegistration = false;
    this.isFromNoCnamgsRegistration = false;
    this.isSubmit = false;
    this.employeeHasNoId = false;
    this.clearNoIdValidators();
    if (this.employeesallList && this.employeesallList.length) {
      this.employeeList = false;
      this.employeeWithCcpsStage1 = false;
    } else {
      this.employeeWithCcpsStage1 = false;
    }
  }

  onChange(value, checked) {
    console.log(value)
    if (checked == false) {
      if (this.idArray.includes(value)) {
        this.idArray = this.idArray.filter(id => id !== value);
        console.log(this.idArray)
      }
    } else {
      this.idArray.push(value);
    }
  }

  resignEmployee(employee) {
    this.employeeDetail = employee;
    this.startat = new Date(this.employeeDetail.join_date);
    this.startat.setHours(0, 0, 0, 0);
    console.log("1369startat", this.startat)
    $('#employeeResignModal').modal('show');
  }

  onSubmitResign() {
    console.log(this.resignationForm)
    this.rsubmitted = true;
    if (this.resignationForm.invalid) {
      return;
    }
    var data = this.resignationForm.value;
    data['employee_id'] = this.employeeDetail.id;
    data['date_of_resignation'] = this.convertOwl(data.date_of_resignation)

    console.log("workingggggggggggggggggggggggggggggg", data)
    this.ngxUiLoaderService.start();
    this.api.resignEmployee(data).pipe(first())
      .subscribe(data => {
        this.rsubmitted = false;
        this.ngxUiLoaderService.stop();
        this.responseresign = data;
        if (this.responseresign.status == 200) {
          $('#employeeResignModal').modal('hide');
          $('#resignation-confirm-modal').modal('hide');
          this.resignationForm.reset();
          this.getEmployeeList(4);
        } else {

        }
        this.snackBar.open(this.responseresign.message, "OK", {
          duration: 5000,
        });
      },
        error => {
          this.rsubmitted = false;
          this.ngxUiLoaderService.stop();
        });
  }

  resignationModalOpen() {
    console.log("21321")
    this.rsubmitted = true;
    if (this.resignationForm.invalid) {
      console.log(this.resignationForm)
      return;
    } else {
      $('#resignation-confirm-modal').modal('show');
    }
  }

  getEmployeeDetails(id) {

    this.router.navigate(['/salary-revise', id]);
  }

  resignHistory(id) {
    this.router.navigate(['/employee-history', id]);
  }
  // getAccountData(id) {
  //   console.log("442 get employer details")
  //   this.ngxUiLoaderService.start();
  //   this.api.getAccountDetails().pipe(first())
  //     .subscribe(res => {
  //         this.ngxUiLoaderService.stop();
  //         this.response = res.results;
  //         if (res.status == 200) {
  //           console.log("88", res)
  //           this.accountDetails = this.response;
  //           const data = JSON.stringify(this.accountDetails);
  //           localStorage.setItem('currentUserDetails', data);

  //         }
  //       },
  //       error => {
  //         console.log("errorrrrrrrrr")
  //         this.ngxUiLoaderService.stop();
  //       });
  //   console.log("no result")
  // }

  setValidator(event) {
    console.log("737", event.target.value)
    const data = event.target.value;
    this.a.resign_reason_document.setValue('');
    this.resign_reason_document = null;

    switch (data) {
      case '14':
        this.a['reason_type'].setValidators([Validators.required]);
        this.a['reason_type'].updateValueAndValidity();
        break;
      case '3':
      case '4':
      case '13':
        this.a['resign_reason_document'].setValidators([Validators.required]);
        this.a['resign_reason_document'].updateValueAndValidity();
        break;

      default:
        this.a['reason_type'].clearValidators();
        this.a['reason_type'].updateValueAndValidity();
        this.a['resign_reason_document'].clearValidators();
        this.a['resign_reason_document'].updateValueAndValidity();
    }
  }

  setFilteredEmployees(e: any) {
    console.log(e);
    this.employeesallList = this.searchList.filter((employeeList: any) => {
      const designation = employeeList.designation || '';
      const mobile = employeeList.mobile || '';
      const name = employeeList.name || '';
      const cnss = employeeList.cnss || '';
      const ccps_code = employeeList.ccps_code || '';

      return (
        designation.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 ||
        mobile.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 ||
        name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 ||
        cnss.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 ||
        ccps_code.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
      );
    });
    // this.getDisplayedData();
  }

  onDropdownChange(val) {
    console.log("Sadadasdsada")
    this.idTypeList();
    this.CcpsStage1Form.get('id_Front_Photo').setValue('');
    this.id_Front_Photo = null;
    // Clear validators for id_Front_Photo
    this.CcpsStage1Form.get('id_Front_Photo').clearValidators();
    if (!this.g.id_type.value) {
    }
    this.CcpsStage1Form.get('id_Front_Photo').updateValueAndValidity();
  }

  getSelectedIdTypeName(): string {
    const idTypeValue = this.g.id_type.value;
    if (!idTypeValue || !this.idtypelist || this.idtypelist.length === 0) {
      return '';
    }
    const selectedIdType = this.idtypelist.find(id => id.id == idTypeValue);
    return selectedIdType ? selectedIdType.name : '';
  }

  scrollToFirstInvalidControl() {
    for (const controlName in this.CcpsStage1Form.controls) {
      const control = this.CcpsStage1Form.get(controlName);
      if (control && control.invalid) {
        // Try to find the control by formControlName first
        let firstInvalidControl = this.elementRef.nativeElement.querySelector(`[formcontrolname="${controlName}"]`);

        // If not found and it's id_Front_Photo, try to find by id
        if (!firstInvalidControl && controlName === 'id_Front_Photo') {
          const idElement = this.elementRef.nativeElement.querySelector(`#id_Front_Photo`);
          if (idElement) {
            firstInvalidControl = idElement;
            // Try to find the parent container
            if (idElement.closest) {
              const parentContainer = idElement.closest('.child-container');
              if (parentContainer) {
                firstInvalidControl = parentContainer;
              }
            }
          }
        }

        // If still not found, try to find the parent container
        if (!firstInvalidControl) {
          const formControlElement = this.elementRef.nativeElement.querySelector(`[formcontrolname="${controlName}"]`);
          if (formControlElement && formControlElement.closest) {
            const parentContainer = formControlElement.closest('.child-container');
            if (parentContainer) {
              firstInvalidControl = parentContainer;
            }
          }
        }

        if (firstInvalidControl) {
          firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          // Also try to focus if it's an input
          if (firstInvalidControl.tagName === 'INPUT' || firstInvalidControl.tagName === 'SELECT') {
            setTimeout(() => {
              try {
                firstInvalidControl.focus();
              } catch (e) {
                // Ignore focus errors
              }
            }, 300);
          }
          break;
        }
      }
    }
  }
  refreshPage() {
    window.location.reload();
  }

  // formatCNSS(event: any) {
  //   let value = event.target.value.replace(/-/g, '');

  //   if (value.length >= 4 && value.length < 11) {
  //     value = value.slice(0, 3) + '-' + value.slice(3);
  //   } else if (value.length >= 11) {
  //     value = value.slice(0, 3) + '-' + value.slice(3, 10) + '-' + value.slice(10);
  //   }

  //   this.CcpsStage1Form.patchValue({ cnss: value });
  // }

  formatCNSS(event: any) {
    let value = event.target.value.replace(/-/g, '');

    if (value.length >= 4 && value.length < 11) {
      value = value.slice(0, 3) + '-' + value.slice(3);
    } else if (value.length >= 11) {
      value = value.slice(0, 3) + '-' + value.slice(3, 10) + '-' + value.slice(10);
    }

    // Capitalize the last letter
    if (value.length > 0) {
      value = value.slice(0, -1) + value.slice(-1).toUpperCase();
    }
    this.CcpsStage1Form.patchValue({ cnss: value });
  }

  formatCNAMGS(event: any) {
    let value = event.target.value.replace(/-/g, '');

    // Insert hyphens based on the length of the value
    if (value.length >= 4 && value.length < 7) {
      value = value.slice(0, 3) + '-' + value.slice(3);
    } else if (value.length >= 7 && value.length < 11) {
      value = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
    } else if (value.length >= 11) {
      value = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 9) + '-' + value.slice(9);
    }

    this.CcpsStage1Form.patchValue({ cnamgs: value });
  }

  subscribeToCNSSRegistrationChanges() {
    const isRegisteredCnssControl = this.CcpsStage1Form.get('is_registered_cnss');
    if (isRegisteredCnssControl) {
      // Get current value or default to 'yes'
      const currentValue = isRegisteredCnssControl.value || 'yes';

      // Ensure initial value is set
      if (!isRegisteredCnssControl.value || isRegisteredCnssControl.value === '') {
        isRegisteredCnssControl.setValue('yes', { emitEvent: false });
      }

      // Set initial value
      this.isRegisteredWithCNSS = currentValue;

      // Apply initial validation based on current value
      // Use setTimeout to ensure form is fully initialized
      setTimeout(() => {
        this.applyCNSSRegistrationValidation(currentValue);
      }, 0);

      // Subscribe to value changes
      isRegisteredCnssControl.valueChanges.subscribe(value => {
        this.isRegisteredWithCNSS = value;
        this.applyCNSSRegistrationValidation(value);
      });
    }
  }

  applyCNSSRegistrationValidation(value: string) {
    const cnssControl = this.CcpsStage1Form.get('cnss');
    const firstNameControl = this.CcpsStage1Form.get('first_name');
    const lastNameControl = this.CcpsStage1Form.get('last_name');
    const typeOfContractControl = this.CcpsStage1Form.get('type_of_contract');
    const maritalStatusControl = this.CcpsStage1Form.get('marital_status');
    const maritalStatusOtherControl = this.CcpsStage1Form.get('marital_status_other');
    const positionControl = this.CcpsStage1Form.get('position');
    const dobControl = this.CcpsStage1Form.get('dob');
    const genderControl = this.CcpsStage1Form.get('gender');
    const mobileControl = this.CcpsStage1Form.get('mobile');
    const emailControl = this.CcpsStage1Form.get('email');
    const idTypeControl = this.CcpsStage1Form.get('id_type');
    const joindateControl = this.CcpsStage1Form.get('joindate');
    const professionalCategoryControl = this.CcpsStage1Form.get('professional_category');
    const employeeTypeControl = this.CcpsStage1Form.get('employee_type');
    const cnamgsControl = this.CcpsStage1Form.get('cnamgs');

    if (value === 'yes') {
      // If Yes, set required validator for CNSS
      if (cnssControl) {
        cnssControl.setValidators([Validators.required, Validators.pattern("^[0-9-]+$")]);
        cnssControl.updateValueAndValidity();
      }
      // Clear validators for fields that are not in CNSS "Yes" flow (these are only for CNAMGS "No" flow)
      if (firstNameControl) {
        firstNameControl.clearValidators();
        firstNameControl.setValue('');
        firstNameControl.updateValueAndValidity();
      }
      if (lastNameControl) {
        lastNameControl.clearValidators();
        lastNameControl.setValue('');
        lastNameControl.updateValueAndValidity();
      }
      if (typeOfContractControl) {
        typeOfContractControl.clearValidators();
        typeOfContractControl.setValue('');
        typeOfContractControl.updateValueAndValidity();
      }
      if (maritalStatusControl) {
        maritalStatusControl.clearValidators();
        maritalStatusControl.updateValueAndValidity();
      }
      if (positionControl) {
        positionControl.clearValidators();
        positionControl.setValue('');
        positionControl.updateValueAndValidity();
      }
      if (dobControl) {
        dobControl.clearValidators();
        dobControl.setValue('');
        dobControl.updateValueAndValidity();
      }
      if (genderControl) {
        genderControl.clearValidators();
        genderControl.setValue('');
        genderControl.updateValueAndValidity();
      }
      if (mobileControl) {
        mobileControl.clearValidators();
        mobileControl.setValue('');
        mobileControl.updateValueAndValidity();
      }
      if (emailControl) {
        emailControl.clearValidators();
        emailControl.setValue('');
        emailControl.updateValueAndValidity();
      }
      if (idTypeControl) {
        idTypeControl.clearValidators();
        idTypeControl.updateValueAndValidity();
      }
      if (joindateControl) {
        joindateControl.clearValidators();
        joindateControl.setValue('');
        joindateControl.updateValueAndValidity();
      }
      if (professionalCategoryControl) {
        professionalCategoryControl.clearValidators();
        professionalCategoryControl.setValue('');
        professionalCategoryControl.updateValueAndValidity();
      }
      if (employeeTypeControl) {
        employeeTypeControl.clearValidators();
        employeeTypeControl.setValue('');
        employeeTypeControl.updateValueAndValidity();
      }
      // Clear CNAMGS validator initially (will be set when CNAMGS question is answered)
      if (cnamgsControl) {
        cnamgsControl.clearValidators();
        cnamgsControl.updateValueAndValidity();
      }
      // Populate common fields when CNSS "No" is selected (Form 3 becomes visible)
      // This happens when user switches from Form 2 (CNAMGS Registration) to Form 3
      // Only populate if form hasn't been initialized yet (first time showing the form)
      if (this.employeeData && !this.formInitialized) {
        this.setCommonFormFields();
      }
      // Clear NIP number when "Yes" is selected
      const nipNumberControl = this.CcpsStage1Form.get('nip_number');
      if (nipNumberControl) {
        nipNumberControl.setValue('');
        nipNumberControl.updateValueAndValidity();
      }
    } else {
      // If No, clear validators from CNSS
      if (cnssControl) {
        cnssControl.clearValidators();
        cnssControl.updateValueAndValidity();
      }
      // For CNSS "No" (full form): do not clear first_name/last_name - no-ID flow keeps validators from applyNoIdValidators
      if (typeOfContractControl) {
        typeOfContractControl.clearValidators();
        typeOfContractControl.setValue('');
        typeOfContractControl.updateValueAndValidity();
      }
      if (maritalStatusControl) {
        maritalStatusControl.clearValidators();
        maritalStatusControl.updateValueAndValidity();
      }
      // Make position optional when No
      if (positionControl) {
        positionControl.clearValidators();
        positionControl.updateValueAndValidity();
      }
    }
  }
  subscribeToCNAMGSRegistrationChanges() {
    const isRegisteredCnamgsControl = this.CcpsStage1Form.get('is_registered_cnamgs');
    if (isRegisteredCnamgsControl) {
      // Watch for changes and update route when "Yes" is selected
      isRegisteredCnamgsControl.valueChanges.subscribe(value => {
        if (value === 'yes') {
          // Navigate with cnamgs=yes parameter
          // Query parameters removed - no longer needed
          // Apply validation for CNAMGS "Yes" (preserve the value)
          const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
          const currentCnamgsValue = cnamgsControl ? cnamgsControl.value : '';
          this.applyCNAMGSRegistrationValidation('yes');
          // Restore the value if it was cleared
          if (cnamgsControl && currentCnamgsValue && !cnamgsControl.value) {
            cnamgsControl.setValue(currentCnamgsValue);
            cnamgsControl.updateValueAndValidity();
          }
        } else if (value === 'no') {
          // Query parameters removed - no longer needed
          // Apply validation for CNAMGS "No"
          this.applyCNAMGSRegistrationValidation('no');
        }
      });
    }
  }

  applyCnamgsYesFormValidation() {
    // Set required validators for CNAMGS "Yes" additional form fields
    const joindateControl = this.CcpsStage1Form.get('joindate');
    const typeOfContractControl = this.CcpsStage1Form.get('type_of_contract');
    const professionalRankControl = this.CcpsStage1Form.get('professional_rank');
    const employeeTypeControl = this.CcpsStage1Form.get('employee_type');
    const contractEndDateControl = this.CcpsStage1Form.get('contract_end_date');
    const employeeTypeOtherControl = this.CcpsStage1Form.get('employee_type_other');
    const positionControl = this.CcpsStage1Form.get('position');

    // Set required validators for mandatory fields
    if (joindateControl) {
      joindateControl.setValidators([Validators.required]);
      joindateControl.updateValueAndValidity();
    }
    if (typeOfContractControl) {
      typeOfContractControl.setValidators([Validators.required]);
      typeOfContractControl.updateValueAndValidity();
    }
    if (professionalRankControl) {
      professionalRankControl.setValidators([Validators.required]);
      professionalRankControl.updateValueAndValidity();
    }
    if (employeeTypeControl) {
      employeeTypeControl.setValidators([Validators.required]);
      employeeTypeControl.updateValueAndValidity();
    }

    // Set conditional validators
    if (contractEndDateControl) {
      if (typeOfContractControl && typeOfContractControl.value === '2') {
        contractEndDateControl.setValidators([Validators.required]);
      } else {
        contractEndDateControl.clearValidators();
      }
      contractEndDateControl.updateValueAndValidity();
    }

    if (employeeTypeOtherControl) {
      if (employeeTypeControl && employeeTypeControl.value === '7') {
        employeeTypeOtherControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      } else {
        employeeTypeOtherControl.clearValidators();
      }
      employeeTypeOtherControl.updateValueAndValidity();
    }

    // Set pattern validator for position (optional field)
    if (positionControl) {
      positionControl.setValidators([Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      positionControl.updateValueAndValidity();
    }
  }

  applyCnamgsNoFormValidation() {
    // Clear validators for fields not used in CNAMGS registration
    const cnssControl = this.CcpsStage1Form.get('cnss');
    const professionalRankControl = this.CcpsStage1Form.get('professional_rank');
    if (cnssControl) {
      cnssControl.clearValidators();
      cnssControl.updateValueAndValidity();
    }
    if (professionalRankControl) {
      professionalRankControl.clearValidators();
      professionalRankControl.updateValueAndValidity();
    }

    // Set required validators for CNAMGS Registration form fields (when "No" is selected)
    const employeePhotoControl = this.CcpsStage1Form.get('employee_Photo');
    const genderControl = this.CcpsStage1Form.get('gender');
    const idTypeControl = this.CcpsStage1Form.get('id_type');
    const dobControl = this.CcpsStage1Form.get('dob');
    const regionControl = this.CcpsStage1Form.get('region');
    const cityControl = this.CcpsStage1Form.get('city');
    const districtControl = this.CcpsStage1Form.get('district');
    const neighborhoodControl = this.CcpsStage1Form.get('neighborhood');
    const birthRegionControl = this.CcpsStage1Form.get('birth_region');
    const birthCityControl = this.CcpsStage1Form.get('birth_city');
    const birthDistrictControl = this.CcpsStage1Form.get('birth_district');
    const birthNeighborhoodControl = this.CcpsStage1Form.get('birth_neighborhood');
    const emailControl = this.CcpsStage1Form.get('email');
    const mobileControl = this.CcpsStage1Form.get('mobile');
    const maritalStatusControl = this.CcpsStage1Form.get('marital_status');
    const maritalStatusOtherControl = this.CcpsStage1Form.get('marital_status_other');
    // const administrativeStatusPublicControl = this.CcpsStage1Form.get('administrative_status_public');
    const administrativeStatusPrivateControl = this.CcpsStage1Form.get('administrative_status_private');
    // const joindateControl = this.CcpsStage1Form.get('joindate');
    // const affiliationTypeControl = this.CcpsStage1Form.get('affiliation_type');

    // Set required validators for mandatory fields
    if (employeePhotoControl) {
      employeePhotoControl.setValidators([Validators.required]);
      employeePhotoControl.updateValueAndValidity();
    }
    if (genderControl) {
      genderControl.setValidators([Validators.required]);
      genderControl.updateValueAndValidity();
    }
    if (idTypeControl) {
      idTypeControl.setValidators([Validators.required]);
      idTypeControl.updateValueAndValidity();
    }
    if (dobControl) {
      dobControl.setValidators([Validators.required]);
      dobControl.updateValueAndValidity();
    }
    if (regionControl) {
      regionControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      regionControl.updateValueAndValidity();
    }
    if (cityControl) {
      cityControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      cityControl.updateValueAndValidity();
    }
    if (districtControl) {
      districtControl.setValidators([Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      districtControl.updateValueAndValidity();
    }
    if (neighborhoodControl) {
      neighborhoodControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      neighborhoodControl.updateValueAndValidity();
    }
    if (birthRegionControl) {
      birthRegionControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      birthRegionControl.updateValueAndValidity();
    }
    if (birthCityControl) {
      birthCityControl.setValidators([Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      birthCityControl.updateValueAndValidity();
    }
    if (birthDistrictControl) {
      birthDistrictControl.setValidators([Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      birthDistrictControl.updateValueAndValidity();
    }
    if (birthNeighborhoodControl) {
      birthNeighborhoodControl.setValidators([Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      birthNeighborhoodControl.updateValueAndValidity();
    }
    if (emailControl) {
      emailControl.setValidators([Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]);
      emailControl.updateValueAndValidity();
    }
    if (mobileControl) {
      mobileControl.setValidators([Validators.required, Validators.pattern("^(77|76|74|66|65|62|60|61)[0-9]{6}$")]);
      mobileControl.updateValueAndValidity();
    }
    if (maritalStatusControl) {
      maritalStatusControl.setValidators([Validators.required]);
      maritalStatusControl.updateValueAndValidity();
    }
    if (administrativeStatusPrivateControl) {
      administrativeStatusPrivateControl.setValidators([Validators.required]);
      administrativeStatusPrivateControl.updateValueAndValidity();
    }
    // if (administrativeStatusPublicControl) {
    //   administrativeStatusPublicControl.setValidators([Validators.required]);
    //   administrativeStatusPublicControl.updateValueAndValidity();
    // }
    // if (joindateControl) {
    //   joindateControl.setValidators([Validators.required]);
    //   joindateControl.updateValueAndValidity();
    // }
    // if (affiliationTypeControl) {
    //   affiliationTypeControl.setValidators([Validators.required]);
    //   affiliationTypeControl.updateValueAndValidity();
    // }
  }

  applyCnssNoFormValidation() {
    // Set required validators for CNSS Registration form fields (when "No" is selected)
    const genderControl = this.CcpsStage1Form.get('gender');
    const dobControl = this.CcpsStage1Form.get('dob');
    const nationalityControl = this.CcpsStage1Form.get('nationality');
    const idTypeControl = this.CcpsStage1Form.get('id_type');
    const mobileControl = this.CcpsStage1Form.get('mobile');
    const emailControl = this.CcpsStage1Form.get('email');
    const professionalCategoryControl = this.CcpsStage1Form.get('professional_category');
    const employeeTypeControl = this.CcpsStage1Form.get('employee_type');
    // const joindateControl = this.CcpsStage1Form.get('joindate');
    const idFrontPhotoControl = this.CcpsStage1Form.get('id_Front_Photo');
    const professionalCategoryOtherControl = this.CcpsStage1Form.get('professional_category_other');
    const employeeTypeOtherControl = this.CcpsStage1Form.get('employee_type_other');
    const maritalStatusControl = this.CcpsStage1Form.get('marital_status');
    const maritalStatusOtherControl = this.CcpsStage1Form.get('marital_status_other');
    const birthRegionControl = this.CcpsStage1Form.get('birth_region');
    const birthCityControl = this.CcpsStage1Form.get('birth_city');
    const birthDistrictControl = this.CcpsStage1Form.get('birth_district');
    const birthNeighborhoodControl = this.CcpsStage1Form.get('birth_neighborhood');
    // const administrativeStatusPublicControl = this.CcpsStage1Form.get('administrative_status_public');
    const administrativeStatusPrivateControl = this.CcpsStage1Form.get('administrative_status_private');
    // const affiliationTypeControl = this.CcpsStage1Form.get('affiliation_type');
    const regionControl = this.CcpsStage1Form.get('region');
    const cityControl = this.CcpsStage1Form.get('city');
    const districtControl = this.CcpsStage1Form.get('district');
    const neighborhoodControl = this.CcpsStage1Form.get('neighborhood');
    const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
    const employeePhotoControl = this.CcpsStage1Form.get('employee_Photo');
    const professionalRankControl = this.CcpsStage1Form.get('professional_rank');

    // Clear validators for unrelated/hidden fields for this flow
    const clear = (ctrl: any) => {
      if (!ctrl) return;
      ctrl.clearValidators();
      ctrl.updateValueAndValidity();
    };
    clear(administrativeStatusPrivateControl);
    // clear(administrativeStatusPublicControl);
    // clear(affiliationTypeControl);
    clear(regionControl);
    clear(birthRegionControl);
    clear(birthCityControl);
    clear(birthDistrictControl);
    clear(birthNeighborhoodControl);
    clear(cityControl);
    clear(districtControl);
    clear(neighborhoodControl);
    clear(cnamgsControl);
    clear(employeePhotoControl);
    clear(professionalRankControl);

    // Set required validators for mandatory fields
    if (genderControl) {
      genderControl.setValidators([Validators.required]);
      genderControl.updateValueAndValidity();
    }
    if (dobControl) {
      dobControl.setValidators([Validators.required]);
      dobControl.updateValueAndValidity();
    }
    if (nationalityControl) {
      nationalityControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      nationalityControl.updateValueAndValidity();
    }
    if (idTypeControl) {
      idTypeControl.setValidators([Validators.required]);
      idTypeControl.updateValueAndValidity();
    }
    if (mobileControl) {
      mobileControl.setValidators([Validators.required, Validators.pattern("^(77|76|74|66|65|62|60|61)[0-9]{6}$")]);
      mobileControl.updateValueAndValidity();
    }
    if (emailControl) {
      emailControl.setValidators([Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]);
      emailControl.updateValueAndValidity();
    }
    if (professionalCategoryControl) {
      professionalCategoryControl.setValidators([Validators.required]);
      professionalCategoryControl.updateValueAndValidity();
    }
    if (employeeTypeControl) {
      employeeTypeControl.setValidators([Validators.required]);
      employeeTypeControl.updateValueAndValidity();
    }
    // if (joindateControl) {
    //   joindateControl.setValidators([Validators.required]);
    //   joindateControl.updateValueAndValidity();
    // }
    if (idFrontPhotoControl) {
      idFrontPhotoControl.setValidators([Validators.required]);
      idFrontPhotoControl.updateValueAndValidity();
    }
    if (maritalStatusControl) {
      maritalStatusControl.setValidators([Validators.required]);
      maritalStatusControl.updateValueAndValidity();
    }

    // Set conditional validators
    if (professionalCategoryOtherControl) {
      if (professionalCategoryControl && professionalCategoryControl.value == '7') {
        professionalCategoryOtherControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      } else {
        professionalCategoryOtherControl.clearValidators();
      }
      professionalCategoryOtherControl.updateValueAndValidity();
    }
    if (maritalStatusOtherControl) {
      if (maritalStatusControl && maritalStatusControl.value == '1') {
        maritalStatusOtherControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      } else {
        maritalStatusOtherControl.clearValidators();
      }
      maritalStatusOtherControl.updateValueAndValidity();
    }
    if (employeeTypeOtherControl) {
      if (employeeTypeControl && employeeTypeControl.value == '7') {
        employeeTypeOtherControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      } else {
        employeeTypeOtherControl.clearValidators();
      }
      employeeTypeOtherControl.updateValueAndValidity();
    }
  }

  onContractTypeChange(value: string) {
    const contractEndDateControl = this.CcpsStage1Form.get('contract_end_date');
    if (contractEndDateControl) {
      if (value == '2') {
        contractEndDateControl.setValidators([Validators.required]);
      } else {
        contractEndDateControl.clearValidators();
        contractEndDateControl.setValue('');
      }
      contractEndDateControl.updateValueAndValidity();
    }
  }

  applyCNAMGSRegistrationValidation(value: string) {
    const cnamgsControl = this.CcpsStage1Form.get('cnamgs');
    const employeePhotoControl = this.CcpsStage1Form.get('employee_Photo');
    const genderControl = this.CcpsStage1Form.get('gender');
    const idTypeControl = this.CcpsStage1Form.get('id_type');
    const dobControl = this.CcpsStage1Form.get('dob');
    const regionControl = this.CcpsStage1Form.get('region');
    const cityControl = this.CcpsStage1Form.get('city');
    const districtControl = this.CcpsStage1Form.get('district');
    const neighborhoodControl = this.CcpsStage1Form.get('neighborhood');
    const birthRegionControl = this.CcpsStage1Form.get('birth_region');
    const birthCityControl = this.CcpsStage1Form.get('birth_city');
    const birthDistrictControl = this.CcpsStage1Form.get('birth_district');
    const birthNeighborhoodControl = this.CcpsStage1Form.get('birth_neighborhood');
    const emailControl = this.CcpsStage1Form.get('email');
    const mobileControl = this.CcpsStage1Form.get('mobile');
    const maritalStatusControl = this.CcpsStage1Form.get('marital_status');
    const maritalStatusOtherControl = this.CcpsStage1Form.get('marital_status_other');
    // const administrativeStatusPublicControl = this.CcpsStage1Form.get('administrative_status_public');
    const administrativeStatusPrivateControl = this.CcpsStage1Form.get('administrative_status_private');
    // const joindateControl = this.CcpsStage1Form.get('joindate');
    // const affiliationTypeControl = this.CcpsStage1Form.get('affiliation_type');

    if (value === 'yes') {
      // If Yes, set required validator for CNAMGS
      if (cnamgsControl) {
        cnamgsControl.setValidators([Validators.required, Validators.pattern("^[0-9-]+$")]);
        cnamgsControl.updateValueAndValidity();
      }
    } else {
      // If No, clear all validators for CNAMGS "No" form fields
      if (cnamgsControl) {
        cnamgsControl.clearValidators();
        cnamgsControl.setValue('');
        cnamgsControl.updateValueAndValidity();
      }
      // Clear all validators for CNAMGS "No" form fields
      if (employeePhotoControl) {
        employeePhotoControl.clearValidators();
        employeePhotoControl.updateValueAndValidity();
      }
      if (genderControl) {
        genderControl.clearValidators();
        genderControl.updateValueAndValidity();
      }
      if (idTypeControl) {
        idTypeControl.clearValidators();
        idTypeControl.updateValueAndValidity();
      }
      if (dobControl) {
        dobControl.clearValidators();
        dobControl.updateValueAndValidity();
      }
      if (regionControl) {
        regionControl.clearValidators();
        regionControl.updateValueAndValidity();
      }
      if (birthRegionControl) {
        birthRegionControl.clearValidators();
        birthRegionControl.updateValueAndValidity();
      }
      if (birthCityControl) {
        birthCityControl.clearValidators();
        birthCityControl.updateValueAndValidity();
      }
      if (birthDistrictControl) {
        birthDistrictControl.clearValidators();
        birthDistrictControl.updateValueAndValidity();
      }
      if (birthNeighborhoodControl) {
        birthNeighborhoodControl.clearValidators();
        birthNeighborhoodControl.updateValueAndValidity();
      }
      if (cityControl) {
        cityControl.clearValidators();
        cityControl.updateValueAndValidity();
      }
      if (districtControl) {
        districtControl.clearValidators();
        districtControl.updateValueAndValidity();
      }
      if (neighborhoodControl) {
        neighborhoodControl.clearValidators();
        neighborhoodControl.updateValueAndValidity();
      }
      if (emailControl) {
        emailControl.clearValidators();
        emailControl.setValidators([Validators.email]);
        emailControl.updateValueAndValidity();
      }
      if (mobileControl) {
        mobileControl.clearValidators();
        mobileControl.setValidators([Validators.minLength(8), Validators.maxLength(8)]);
        mobileControl.updateValueAndValidity();
      }
      if (maritalStatusControl) {
        maritalStatusControl.clearValidators();
        maritalStatusControl.updateValueAndValidity();
      }
      if (administrativeStatusPrivateControl) {
        administrativeStatusPrivateControl.clearValidators();
        administrativeStatusPrivateControl.updateValueAndValidity();
      }
      // if (administrativeStatusPublicControl) {
      //   administrativeStatusPublicControl.clearValidators();
      //   administrativeStatusPublicControl.updateValueAndValidity();
      // }
      // if (joindateControl) {
      //   joindateControl.clearValidators();
      //   joindateControl.updateValueAndValidity();
      // }
      // if (affiliationTypeControl) {
      //   affiliationTypeControl.clearValidators();
      //   affiliationTypeControl.updateValueAndValidity();
      // }
    }
  }

  clearJoinDate() {

    this.g['joindate'].setValue(null);
    this.g['joindate'].updateValueAndValidity();
    this.minJoinDate = new Date(this.accountDetails.company_creation_date)
    this.minJoinDate.setHours(0, 0, 0, 0);
  }
  view() {
    this.showAll = !this.showAll;
    if (this.showAll) {
      console.log("244", this.currentLang)
      if (this.currentLang == 'fr') {
        $("#view").text('Voir moins')
      } else {
        $("#view").text('View Less')
      }
    } else {
      console.log("252", this.currentLang)
      if (this.currentLang == 'fr') {
        $("#view").text('Voir plus')
      } else {
        $("#view").text('View More')
      }

    }
  }
  onProfessionalCategoryChange(value: string) {
    this.selectedProfessionalCategory = value;
    const professionalCategoryOtherControl = this.CcpsStage1Form.get('professional_category_other');
    if (professionalCategoryOtherControl) {
      if (value == '7') {
        professionalCategoryOtherControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      } else {
        professionalCategoryOtherControl.clearValidators();
        professionalCategoryOtherControl.setValue('');
      }
      professionalCategoryOtherControl.updateValueAndValidity();
    }
  }
  onMaritalStatusChange(value: string) {
    this.selectedMaritalStatus = value;
    const maritalStatusOtherControl = this.CcpsStage1Form.get('marital_status_other');
    if (maritalStatusOtherControl) {
      if (value == '1') {
        maritalStatusOtherControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      } else {
        maritalStatusOtherControl.clearValidators();
      }
      maritalStatusOtherControl.updateValueAndValidity();
    }
  }

  onEmployeeTypeChange(value: string) {
    this.selectedEmployeeType = value;
    const employeeTypeOtherControl = this.CcpsStage1Form.get('employee_type_other');
    if (employeeTypeOtherControl) {
      if (value == '7') {
        employeeTypeOtherControl.setValidators([Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]);
      } else {
        employeeTypeOtherControl.clearValidators();
        employeeTypeOtherControl.setValue('');
      }
      employeeTypeOtherControl.updateValueAndValidity();
    }
  }

  genderChange(e) {
    console.log(e)
    // Clear validators for maiden_name regardless of gender
    this.g['maiden_name'].clearValidators();
    this.g['maiden_name'].updateValueAndValidity();
  }
  pendingEmpoyeeModal() {
    this.isFromCnamgsYesRegistration = false;
    this.isFromNoCnamgsRegistration = false;
    this.isFromNoCnssRegistration = false;
    if (this.pendingEmployeeCount >= '1') {
      $('#allEmployeeModal').modal('show');
    } else {
      return;
    }
  }

  onPageChange(event): void {
    this.currentPage = event.pageIndex;
    console.log("1634", this.currentPage)
    this.getDisplayedData();
  }

  getDisplayedData(): any[] {

    if (this.employeesallList && this.employeesallList.length === 0 || this.currentPage < 0) {
      return [];
    }
    if (this.employeesallList) {
      const startIndex = this.currentPage * this.itemsPerPage;
      const endIndex = Math.min(startIndex + this.itemsPerPage, this.employeesallList.length);

      return this.employeesallList.slice(startIndex, endIndex);
    }

  }

  translateLabels(translations: any): void {
    this.paginatorIntl.itemsPerPageLabel = translations['Items per page'];
    console.log("198", this.paginatorIntl)
  }

  // Get previous month date
  getPreviousMonth(): Date {
    const today = new Date();
    const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    return previousMonth;
  }



  initMonthsUpToPrevious() {
    const currentMonthIndex = new Date().getMonth(); // 0 = January
    // Slice till previous month (currentMonthIndex is 0-based, so slice(0, currentMonthIndex) gives months up to previous month)
    this.availableMonths = this.months.slice(0, currentMonthIndex);

    // Auto-select the first available month
    if (this.availableMonths.length > 0 && this.CcpsStage1Form) {
      setTimeout(() => {
        const monthControl = this.CcpsStage1Form.get('month');
        if (monthControl) {
          monthControl.setValue(this.availableMonths[0].value);
        }
      }, 100);
    }
  }

  onYearChange(selectedYear: number) {
    // Convert selectedYear to number to ensure proper comparison
    const selectedYearNum = Number(selectedYear);

    const currentYear = new Date().getFullYear();
    const currentMonthIndex = new Date().getMonth(); // 0 = January

    // Get join date to determine starting month
    const joinDate = this.CcpsStage1Form.get('joindate').value;

    let joinYear = null;
    let joinMonthIndex = 0; // 0-based (0 = January)

    if (joinDate) {
      const joinDateObj = new Date(joinDate);
      joinYear = joinDateObj.getFullYear();
      joinMonthIndex = joinDateObj.getMonth(); // 0-based (0 = January)
    }

    // Determine which months to show based on selected year
    if (selectedYearNum === joinYear) {
      // Join year: show from join month onwards
      if (selectedYearNum === currentYear) {
        // Join year is also current year: show from join month to previous month
        this.availableMonths = this.months.slice(joinMonthIndex, currentMonthIndex);
      } else {
        // Join year is in the past: show from join month to December
        this.availableMonths = this.months.slice(joinMonthIndex);
      }
    } else if (selectedYearNum === currentYear) {
      // Current year (not join year): show January to previous month
      this.availableMonths = this.months.slice(0, currentMonthIndex);
    } else {
      // Past year (not join year): show all 12 months
      this.availableMonths = this.months.slice(0);
    }

    // Get salaries for the selected year
    const yearStr = selectedYearNum.toString();
    const yearSalaries = this.salaryListByYear[yearStr] || [];

    // Reset month selection and find first available month for this year
    const nextAvailableMonth = this.availableMonths.find(m => {
      const monthStr = m.value.toString().padStart(2, '0');
      return !yearSalaries.some(item => item.month === monthStr);
    });

    if (nextAvailableMonth) {
      this.CcpsStage1Form.patchValue({ month: nextAvailableMonth.value });
    } else if (this.availableMonths.length > 0) {
      this.CcpsStage1Form.patchValue({ month: this.availableMonths[0].value });
    } else {
      this.CcpsStage1Form.patchValue({ month: '' });
    }
  }

  initAvailableYears() {
    // Initialize with current year if no join date is set yet
    const currentYear = new Date().getFullYear();
    this.availableYears = [currentYear];
  }

  subscribeToJoinDateChanges() {
    // Watch for join date changes and update available years
    this.CcpsStage1Form.get('joindate').valueChanges.subscribe(joinDate => {
      if (joinDate) {
        this.updateAvailableYearsFromJoinDate(joinDate);
      }
    });
  }

  subscribeToIdTypeChanges() {
    // Clear validators for id_Front_Photo regardless of id_type value
    const idTypeControl = this.CcpsStage1Form.get('id_type');
    if (idTypeControl) {
      // Clear validators initially
      this.CcpsStage1Form.get('id_Front_Photo').clearValidators();
      this.CcpsStage1Form.get('id_Front_Photo').updateValueAndValidity();

      // Watch for id_type changes and clear validators
      idTypeControl.valueChanges.subscribe(idType => {
        this.CcpsStage1Form.get('id_Front_Photo').clearValidators();
        if (!idType) {
          this.CcpsStage1Form.get('id_Front_Photo').setValue('');
        }
        this.CcpsStage1Form.get('id_Front_Photo').updateValueAndValidity();
      });
    }
  }

  updateAvailableYearsFromJoinDate(joinDate: Date) {
    if (!joinDate) return;

    const joinDateObj = new Date(joinDate);
    const joinYear = joinDateObj.getFullYear();
    const joinMonth = joinDateObj.getMonth() + 1; // 1-based month (1 = January, 12 = December)
    const currentYear = new Date().getFullYear();

    // Clean up salaries that are before the join date
    // Remove all salaries from years before join year
    Object.keys(this.salaryListByYear).forEach(yearStr => {
      const year = parseInt(yearStr, 10);

      if (year < joinYear) {
        // Remove entire year if before join year
        delete this.salaryListByYear[yearStr];
      } else if (year === joinYear) {
        // For join year, remove months before join month
        const yearSalaries = this.salaryListByYear[yearStr];
        if (yearSalaries && yearSalaries.length > 0) {
          this.salaryListByYear[yearStr] = yearSalaries.filter(item => {
            const itemMonth = parseInt(item.month, 10);
            return itemMonth >= joinMonth;
          });

          // If no salaries left for this year, remove the year entry
          if (this.salaryListByYear[yearStr].length === 0) {
            delete this.salaryListByYear[yearStr];
          }
        }
      }
    });

    // Generate years from join year to current year
    this.availableYears = [];
    for (let year = joinYear; year <= currentYear; year++) {
      this.availableYears.push(year);
    }

    // Re-initialize year expansion for new years
    this.initializeYearExpansion();

    // Reset form fields (year, month, amount)
    const yearControl = this.CcpsStage1Form.get('year');
    const monthControl = this.CcpsStage1Form.get('month');
    const amountControl = this.CcpsStage1Form.get('amount');

    // Reset editing state
    this.isEditing = false;
    this.editingIndex = null;
    this.editingYear = null;

    // Set default year in form to most recent year
    if (this.availableYears.length > 0) {
      const mostRecentYear = this.availableYears[this.availableYears.length - 1];
      yearControl.setValue(mostRecentYear);
      this.onYearChange(mostRecentYear);
    } else {
      yearControl.setValue('');
      monthControl.setValue('');
      amountControl.setValue(null);
    }
  }

  initializeYearExpansion() {
    // Initialize expansion state for each year (last year expanded by default)
    this.availableYears.forEach((year, index) => {
      // Only set expansion if not already set
      if (this.expandedYears[year.toString()] === undefined) {
        this.expandedYears[year.toString()] = index === this.availableYears.length - 1;
      }
      // Initialize empty array for each year if not exists
      if (!this.salaryListByYear[year.toString()]) {
        this.salaryListByYear[year.toString()] = [];
      }
    });
  }

  toggleYearExpansion(year: number) {
    const yearStr = year.toString();
    this.expandedYears[yearStr] = !this.expandedYears[yearStr];
  }

  getYearSalaries(year: number) {
    const yearStr = year.toString();
    return this.salaryListByYear[yearStr] || [];
  }

  getYearTotal(year: number): number {
    const yearSalaries = this.getYearSalaries(year);
    return yearSalaries.reduce((acc, item) => acc + (item.value || 0), 0);
  }

  getAllYearsTotal(): number {
    let total = 0;
    this.availableYears.forEach(year => {
      total += this.getYearTotal(year);
    });
    return total;
  }

  formatSalaryForPayload() {
    // Convert salaryListByYear to the required payload format
    const salaryArray = [];

    Object.keys(this.salaryListByYear).forEach(year => {
      const yearSalaries = this.salaryListByYear[year];

      if (yearSalaries && yearSalaries.length > 0) {
        const yearObj = {};
        yearObj[year] = yearSalaries.map(item => ({
          month: item.month,
          value: item.value,
          salary_id: item.salary_id
        }));
        salaryArray.push(yearObj);
      }
    });

    return salaryArray;
  }



  formatEmployeeDataForModal(apiResponse: any) {
    // Get form values
    const formData = this.CcpsStage1Form.getRawValue();

    // Try to get employee data from API response first, fallback to form data
    const apiEmployee = (apiResponse && apiResponse.results) || (apiResponse && apiResponse.result) || (apiResponse && apiResponse.data) || {};

    // Construct full name - prefer API response, fallback to form
    const firstName = apiEmployee.first_name || formData.first_name || '';
    const lastName = apiEmployee.last_name || formData.last_name || '';
    const fullName = `${firstName} ${lastName}`.trim();

    // Format date of birth - prefer API response, fallback to form
    let dobFormatted = '';
    const dobValue = apiEmployee.dob || formData.dob;
    if (dobValue) {
      const dobDate = new Date(dobValue);
      if (!isNaN(dobDate.getTime())) {
        dobFormatted = this.datePipe.transform(dobDate, 'dd-MM-yyyy') || '';
      } else if (typeof dobValue === 'string' && dobValue.includes('-')) {
        // If it's already formatted as dd-MM-yyyy, use it directly
        dobFormatted = dobValue;
      }
    }

    // Calculate total salary for the first available year
    let totalSalary = 0;
    let salaryYear = '';
    const years = Object.keys(this.salaryListByYear).sort();
    if (years.length > 0) {
      salaryYear = years[0];
      const yearSalaries = this.salaryListByYear[salaryYear];
      if (yearSalaries && yearSalaries.length > 0) {
        totalSalary = yearSalaries.reduce((sum, item) => sum + (item.value || 0), 0);
      }
    }

    // Get employee ID from API response or use a temporary ID
    const employeeId = apiEmployee.id ||
      (apiResponse && apiResponse.results && apiResponse.results.id) ||
      (apiResponse && apiResponse.result && apiResponse.result.id) ||
      (apiResponse && apiResponse.id) ||
      Date.now().toString();

    // Return formatted employee data
    return {
      id: employeeId,
      name: fullName,
      dob_type: dobFormatted,
      designation: apiEmployee.designation || apiEmployee.position || formData.position || '',
      cnamgs: apiEmployee.cnamgs || formData.cnamgs || null,
      cnss: null, // Since they selected "No" for CNSS registration
      mobile: apiEmployee.mobile || formData.mobile || '',
      salary: totalSalary,
      year: salaryYear || new Date().getFullYear().toString()
    };
  }

  addSalary() {
    const { year, month, amount } = this.CcpsStage1Form.value;

    if (!year || !month || !amount) {
      this.snackBar.open("Please fill all fields!", "OK", { duration: 3000 });
      return;
    }

    const yearStr = year.toString();
    const monthStr = month.toString().padStart(2, '0');
    const amountNum = Number(amount);

    // Initialize year array if it doesn't exist
    if (!this.salaryListByYear[yearStr]) {
      this.salaryListByYear[yearStr] = [];
    }

    if (this.isEditing && this.editingIndex !== null && this.editingYear) {
      // Editing existing entry
      const yearSalaries = this.salaryListByYear[this.editingYear];

      // Check if month exists in another entry for this year
      const exists = yearSalaries.some((item, idx) =>
        item.month === monthStr && idx !== this.editingIndex
      );

      if (exists && this.editingYear === yearStr) {
        this.snackBar.open("This month's salary has already been added for this year!", "OK", {
          duration: 3000,
        });
        return;
      }

      // Remove from old year if year changed
      if (this.editingYear !== yearStr) {
        const oldYearSalaries = this.salaryListByYear[this.editingYear];
        const salaryId = oldYearSalaries[this.editingIndex].salary_id;
        oldYearSalaries.splice(this.editingIndex, 1);

        // Add to new year
        this.salaryListByYear[yearStr].push({
          month: monthStr,
          value: amountNum,
          salary_id: salaryId
        });
      } else {
        // Update in same year
        yearSalaries[this.editingIndex] = {
          month: monthStr,
          value: amountNum,
          salary_id: yearSalaries[this.editingIndex].salary_id
        };
      }

      this.isEditing = false;
      this.editingIndex = null;
      this.editingYear = null;
    } else {
      // Adding new entry
      const yearSalaries = this.salaryListByYear[yearStr];

      // Check if month already exists for this year
      const exists = yearSalaries.some(item => item.month === monthStr);

      if (exists) {
        this.snackBar.open("This month's salary has already been added for this year!", "OK", {
          duration: 3000,
        });
        return;
      }

      yearSalaries.push({
        month: monthStr,
        value: amountNum
      });
    }

    // Auto-select next available month for the current year
    const currentYearSalaries = this.salaryListByYear[yearStr];
    const nextAvailableMonth = this.availableMonths.find(m => {
      const monthStr = m.value.toString().padStart(2, '0');
      return !currentYearSalaries.some(item => item.month === monthStr);
    });

    // Reset form and auto-select next month
    if (nextAvailableMonth) {
      this.CcpsStage1Form.patchValue({ month: nextAvailableMonth.value, amount: null });
    } else {
      this.CcpsStage1Form.patchValue({ month: '', amount: null });
    }
  }

  editSalaryByYear(year: number, index: number) {
    const yearStr = year.toString();
    const yearSalaries = this.salaryListByYear[yearStr];
    const item = yearSalaries[index];

    // Fill form with existing values
    this.CcpsStage1Form.patchValue({
      year: year,
      month: parseInt(item.month, 10),
      amount: item.value
    });

    this.isEditing = true;
    this.editingIndex = index;
    this.editingYear = yearStr;
  }

  deleteSalaryByYear(year: number, index: number) {
    const yearStr = year.toString();
    this.salaryListByYear[yearStr].splice(index, 1);

    // Reset form
    this.CcpsStage1Form.patchValue({ month: '', amount: null });
  }

  showPendingEmployees() {
    this.getEmployeeList(2);
  }


  chosenYearHandler(e: Date) {
    const initialDate = new Date(e);
    const extractedYear = initialDate.getFullYear();

    const minYear = this.minReportDate ? this.minReportDate.getFullYear() : new Date().getFullYear();
    const maxYear = this.todayDate.getFullYear();

    console.log(extractedYear);

    if (extractedYear >= minYear && extractedYear <= maxYear) {
      this.contactForm.controls['year'].setValue(extractedYear);
    } else {
      console.warn('Selected year is out of range');
    }

    if (this.dateTimePicker) {
      this.dateTimePicker.close();
    }
  }

  openBulkUploadModal() {
    this.contactForm.reset();
    this.contactForm.controls['year'].setValue(this.todayDate.getFullYear().toString());
    this.contactForm.controls['quarter'].setValue('1');
    $('#bulkUpload').modal('hide');
    $('#reportModal').modal('show');
  }

  onBulkUploadNext() {
    if (this.contactForm.invalid) {
      return;
    }
    // Store year and quarter for later use in bulkUpload
    this.selectedBulkUploadYear = this.contactForm.get('year').value;
    this.selectedBulkUploadQuarter = this.contactForm.get('quarter').value;
    $('#reportModal').modal('hide');
    // Trigger file input programmatically
    setTimeout(() => {
      document.getElementById('bulkUploadEmployee').click();
    }, 300);
  }

  closeGenrateReport() {
    $('#reportModal').modal('hide');

  }

  withCcpsIdFormCall() {

    //this.idTypeList();
    this.resetFields();
    this.getCountryData();
    this.getRegionData();
    this.contractTypeList();
    this.getEducationList()
    this.getProfessionalRankList();
    this.getEmployeeTypeList();
    this.getMaritalStatusList();
    this.getProfessionalCategoryList();
    this.getAffiliationTypeList();
    this.getEmployeeCategoryList();
    this.getAdministrativeStatusList();
    this.clearJoinDate();
    $('#addEmployeeModal').modal('hide');
    setTimeout(function () {
      $('#employeeWithCcpsModal').modal('show');
    }, 500);

    this.employeeWithCcps = true;
    console.log("employeeWithCcps", this.employeeWithCcps)

  }

  deletePendingEmployee(uuid: any) {
    const data = {
      uuid: uuid
    }
    this.ngxUiLoaderService.start();
    this.api.employeeHiringDelete(data).pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();
        this.response = data;
        console.log(this.response, "response")
        if (this.response.status == 200) {
          this.snackBar.open(this.response.message, "ok", {
            duration: 2000,
          });
          this.closeModal();
        } else {
          this.snackBar.open(this.response.message, "ok", {
            duration: 2000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }


  // loadEmployeeData() {
  //   this.api.getEmployeeData().subscribe(data => {
  //     console.log(data);
  //     this.response = data;
  //     if (this.response) {
  //       this.employeeDataList = this.response.results;
  //       console.log("employeeData", this.employeeDataList)
  //     } else {
  //       this.snackBar.open(this.response.message, "OK", {
  //         duration: 5000,
  //       });
  //     }
  //   }, error => {

  //   });
  // }
  getProfessionalRankList() {
    this.api.getProfessionalRankList().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        this.response = data;
        if (this.response.status == 200) {
          this.professionalRankList = this.response.results;
          console.log(this.professionalRankList, "professionalRankList")
        } else {
          this.snackBar.open(this.contract.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }
  getEmployeeTypeList() {
    this.api.getEmployeeTypeList().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        this.response = data;
        if (this.response.status == 200) {
          this.employeeTypeList = this.response.results;
          console.log(this.employeeTypeList, "employeeTypeList")
        } else {
          this.snackBar.open(this.contract.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }
  getMaritalStatusList() {
    this.api.getMaritalStatusList().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        this.response = data;
        if (this.response.status == 200) {
          this.maritalStatusList = this.response.results;
          console.log(this.maritalStatusList, "maritalStatusList")
        } else {
          this.snackBar.open(this.contract.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }
  getProfessionalCategoryList() {
    this.api.getProfessionalCategoryList().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        this.response = data;
        if (this.response.status == 200) {
          this.professionalCategoryList = this.response.results;
          console.log(this.professionalCategoryList, "professionalCategoryList")
        } else {
          this.snackBar.open(this.contract.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }
  getAffiliationTypeList() {
    this.api.getAffiliationTypeList().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        this.response = data;
        if (this.response.status == 200) {
          this.affiliationTypeList = this.response.results;
          console.log(this.affiliationTypeList, "affiliationTypeList")
        } else {
          this.snackBar.open(this.contract.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }
  getEmployeeCategoryList() {
    this.api.getEmployeeCategoryList().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        this.response = data;
        if (this.response.status == 200) {
          this.categoryList = this.response.results;
          console.log(this.categoryList, "categoryList")
        } else {
          this.snackBar.open(this.contract.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }
  getAdministrativeStatusList() {
    this.api.getAdministrativeStatusList().pipe(first())
      .subscribe(data => {
        console.log(data, '777777');

        this.response = data;
        if (this.response.status == 200) {
          this.administrativeStatusList = this.response.results;
          console.log(this.administrativeStatusList, "administrativeStatusList")
        } else {
          this.snackBar.open(this.contract.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => { });
  }

}
